/* eslint-disable */
import { AxiosPromise } from 'axios';
import ApiService, { IAjaxOptions, AxiosMethod } from '@app/Services/ApiService';
export class BaseApiModelClass< T > {
    constructor(data?: T & {}) {
        if (data)
            for (let property in data)
                if (data.hasOwnProperty(property))
                    (< any >this)[property] = (< any >data)[property];
    }
}
export interface IAircraftAllParams {}
export interface IAircraftPUTParams {
    body?: AircraftUpdateRequest
}
export interface IAircraftPOSTParams {
    body?: AircraftCreateRequest
}
export interface ITypesAllParams {}
export interface ITypesParams {
    body?: AircraftTypeCreateRequest
}
export interface IGroupsAllParams {}
export interface IGroupsParams {
    body?: AircraftTypeGroupCreateRequest
}
export interface IDeletePOSTParams {
    id: string
}
export interface IDeletePOST2Params {
    id: string
}
export interface INightstopCorrectionParams {
    body?: AircraftTypeNightstopUpdateRequest
}
export interface INightstopCorrectionLogParams {
    aircraftId?: string
}
export interface IAircraftFamilyParams {}
export interface IPantryCodesParams {
    aircraftId?: string
}
export interface IRowsAllParams {
    aircraftId?: string
}
export interface IRowsPUTParams {
    body?: AircraftPantryWeightUpdateRequest
}
export interface IRowsDELETEParams {
    aircraftId?: string
}
export interface IRowsDELETE2Params {
    id: string
}
export interface IRowsLogParams {
    aircraftId?: string
}
export interface IImportParams {
    aircraftId?: string
    contentType?: string
    contentDisposition?: string
    headers?: { [key: string]: string[]; }
    length?: number
    name?: string
    fileName?: string
}
export interface IAirportParams {
    includeALl?: boolean
}
export interface IGridParams {
    body?: AirportsListFilter
}
export interface IHotelDetailsAllParams {
    fourLetterCode: string
}
export interface IHotelDetailsParams {
    fourLetterCode: string
    body?: AirportHotelDetailsUpdateRequest
}
export interface IHotelDetailsLogParams {
    fourLetterCode: string
}
export interface ILogParams {
    fourLetterCode: string
}
export interface ISearchParams {
    search?: string
    includeAll?: boolean
    stationFourLetterCode?: string
}
export interface ILookupAllParams {
    search?: string
    page?: number
    pageSize?: number
    includeDisabled?: boolean
}
export interface ILookupParams {
    threeLetterCode: string
}
export interface ICarrierParams {}
export interface IConfigurationAllParams {
    keys?: string
}
export interface IConfigurationParams {
    body?: ConfigurationModel
}
export interface IEmailParams {
    body?: EmailFilter
}
export interface IBodyParams {
    emailId?: string
}
export interface IAttachmentsParams {
    emailId?: string
}
export interface IAttachmentParams {
    id?: string
}
export interface IValidateParams {
    body?: EmailValidateRequest
}
export interface IUpdateStatusParams {
    id: string
    status: MailQueueStatus
}
export interface IListPOSTParams {
    body?: FileExplorerListRequest
}
export interface IFlightParams {
    body?: FlightsListFilter
}
export interface IFlightAllParams {
    dateFrom?: Date
    dateTo?: Date
    needsAttention?: boolean
}
export interface IFullParams {
    dateFrom?: Date
    dateTo?: Date
    needsAttention?: boolean
}
export interface ILegacyParams {
    dateFrom?: Date
    dateTo?: Date
}
export interface IEnzianParams {
    dateFrom?: Date
    dateTo?: Date
}
export interface IDelaysParams {
    id: string
}
export interface ICrewParams {
    id: string
}
export interface IWeightParams {
    id: string
}
export interface IPantryCodes2Params {
    id: string
}
export interface IPantryCodeParams {
    id: string
    body?: FlightPantryCodeOverrideUpdateRequest
}
export interface IInputHistoryParams {
    id: string
}
export interface ICargoParams {
    id: string
    body?: FlightCargoUpdateRequest
}
export interface IHistoryParams {
    id: string
}
export interface ICalculationsParams {
    id: string
}
export interface ISendStateParams {
    id: string
}
export interface IPublishParams {
    id: string
}
export interface IForceResendParams {
    id: string
}
export interface INetlineOpsXmlParams {
    id: string
}
export interface IEnzianXmlParams {
    id: number
}
export interface ISeatSummariesParams {
    id: string
}
export interface IHistory2Params {
    id: string
}
export interface ICabinVersionsParams {
    id: string
}
export interface IFlight2Params {
    id: string
    body?: FlightUpdateModel
}
export interface IPnlEmailParams {
    id: string
    body?: FlightPnlEmailRequest
}
export interface IImport2Params {
    id: string
}
export interface IAircraftParams {}
export interface IAircraftMaintenanceParams {
    dateFrom?: Date
    dateTo?: Date
}
export interface IMessagesParams {
    id: string
}
export interface IRebuildParams {
    id: string
    updateEnzian?: boolean
}
export interface IEnzianResyncParams {
    id: string
}
export interface IPublish2Params {
    id: string
}
export interface IRepublishParams {
    id: string
}
export interface ILookupsParams {}
export interface INextLegParams {
    airlineRcd?: string
    flightNumber?: number
    dateOfOrigin?: Date
}
export interface IRouteHintsParams {
    airlineRcd?: string
    flightNumber?: number
    dateOfOrigin?: Date
}
export interface IFlightNumberHintsParams {
    airlineRcd?: string
    originRcd?: string
    destinationRcd?: string
    dateOfOrigin?: Date
}
export interface IConfigurationHintParams {
    airlineRcd: string
    aircraftTypeRcd: string
    aircraftId?: string
    flightNumber?: number
    originRcd?: string
    destinationRcd?: string
    dateOfOrigin?: Date
}
export interface IManualGETParams {
    id: string
}
export interface IManualPUTParams {
    id: string
    body?: ManualFlightUpdateRequest
}
export interface IManualPOSTParams {
    body?: ManualFlightCreateRequest
}
export interface ICancelParams {
    id: string
}
export interface IListGETParams {}
export interface IStartParams {
    jobName: string
    body?: JobStartModel
}
export interface IParametersGETParams {
    jobName: string
    triggerName?: string
    isJobSettings?: boolean
}
export interface IValidationParams {
    cronExpression: string
}
export interface IParametersPOSTParams {
    triggerName: string
    body?: JobSaveParametersModel
}
export interface ISettingsParams {
    jobName: string
    body?: JobSaveParametersModel
}
export interface ICreateParams {
    body?: JobSaveParametersModel
}
export interface IDeleteDELETEParams {
    triggerId?: string
    jobName?: string
}
export interface IStopParams {
    jobName: string
}
export interface ICheckTriggerNameParams {
    triggerName?: string
}
export interface ICarrierCodesParams {
    carrierCode?: string
}
export interface IStationCodesAllParams {
    carrierCode?: string
}
export interface IStationCodesParams {
    body?: StationPantryCodeUpdateRequest
}
export interface IStationCodeLogParams {
    airportFourLetterCode?: string
    carrierCode?: string
}
export interface IFutureDestinationPantryStatusParams {}
export interface IImportAllParams {
    contentType?: string
    contentDisposition?: string
    headers?: { [key: string]: string[]; }
    length?: number
    name?: string
    fileName?: string
    removeExtraData?: boolean
    dryRun?: boolean
}
export interface IPersonsPOSTParams {
    body?: PeopleAssistIllnessFilter
}
export interface IPersonsGETParams {
    personCode: string
}
export interface ILiveParams {
    personCode: string
}
export interface IEntriesPOSTParams {
    body?: PeopleAssistFilter
}
export interface IEntriesGETParams {
    kind: PeopleAssistEntryKind
    id: string
}
export interface IFormsPOSTParams {
    body?: PeopleAssistLiveFilter
}
export interface IFormsGETParams {
    id: string
}
export interface IByNumberParams {
    number: number
    statuses?: string
}
export interface IFormsGET2Params {}
export interface IMacrosParams {}
export interface ICustomStatusParams {}
export interface IEmployeesParams {
    search?: string
    value?: string
}
export interface IPermissionParams {}
export interface IRoleParams {}
export interface IRole2Params {
    roleId: number
}
export interface IMonitoringParams {}
export interface IJobParams {
    jobName: string
    duration?: number
}
export interface IJobsPOSTParams {}
export interface IJobsGETParams {}
export interface IMessagebusPOSTParams {}
export interface IMessagebusGETParams {}
export interface IMessageTypeHealthParams {
    forceRefresh?: boolean
}
export interface IIntegrationHealthParams {}
export interface IFlightEnzianChangesQueueParams {}
export interface IAirportQueueParams {}
export interface IWeightQueueParams {}
export interface IDatabasePOSTParams {}
export interface IDatabaseGETParams {}
export interface IUpdateDatabaseParams {}
export interface IDownloadMessagesParams {
    fromDateTime?: Date
    toDateTime?: Date
    labelFilter?: string
    tagFilter?: string
}
export interface IMessageLabelsParams {
    fromDateTime?: Date
    toDateTime?: Date
}
export interface IMessageTagsParams {
    fromDateTime?: Date
    toDateTime?: Date
    labelFilter?: string
}
export interface IMessagesDatesParams {}
export interface IDownloadSapImportsParams {
    date?: Date
}
export interface IDownloadSapExportsParams {
    date?: Date
}
export interface ISapImportDatesParams {}
export interface ISapExportDatesParams {}
export interface IDownloadDeadlettersParams {
    queueName?: string
}
export interface IDatesParams {}
export interface ILogFilesParams {
    date?: Date
}
export interface IDownloadLogParams {
    file?: string
}
export interface IDownloadLogGzParams {
    file?: string
}
export interface ILogFileParams {
    file?: string
}
export interface IMessageStatisticsParams {
    dateTimeFrom?: Date
    queueId?: number
}
export interface IRestartSchedulerParams {}
export interface IInputQueueStatisticsParams {
    body?: InputQueueStatisticsRequestModel
}
export interface IQueueNamesParams {}
export interface IInputQueueDeadlettersPOSTParams {
    body?: InputQueueDeadlettersRequestModel
}
export interface IInputQueueDeadlettersDELETEParams {
    id?: string
    queueName?: string
}
export interface ISignalRUserParams {}
export interface IRowsAll2Params {
    aircraftId?: string
}
export interface IRowsPUT2Params {
    body?: WaterQuantityWeightCorrectionUpdateRequest
}
export interface IRowsDELETE3Params {
    aircraftId: string
    waterLevel: number
}
export interface IRowsLog2Params {
    aircraftId?: string
}
export interface IAircraftTypeGroupsParams {
    fourLetterCode?: string
}
export interface IStationLegsAllParams {
    fourLetterCode?: string
}
export interface IStationLegsPOSTParams {
    originFourLetterCode?: string
    destinationFourLetterCode?: string
}
export interface IStationLegsDELETEParams {
    originFourLetterCode?: string
    destinationFourLetterCode?: string
}
export interface IStationLegQuantitiesAllParams {
    fourLetterCode?: string
}
export interface IStationLegQuantitiesParams {
    body?: StationWaterQuantityLegUpdateRequest
}
export interface IStationNoWaterUpliftParams {
    body?: AirportNoWaterUpliftUpdateRequest
}
export interface IStationLegQuantityLogParams {
    fourLetterCode?: string
}
export interface IFutureFlightWaterQuantityStatusParams {}
export interface IImportAll2Params {
    contentType?: string
    contentDisposition?: string
    headers?: { [key: string]: string[]; }
    length?: number
    name?: string
    fileName?: string
    removeExtraData?: boolean
    dryRun?: boolean
}
export class ApiClient {
    private baseUrl: string;
    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    aircraftGet( requestOptions?: IAjaxOptions): AxiosPromise<AircraftDto[]> {
        let _url = this.baseUrl + "/api/Aircraft";
        return ApiService.sendRequest<AircraftDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    aircraftPut(body: AircraftUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Aircraft";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    aircraftPost(body: AircraftCreateRequest, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Aircraft";
        return ApiService.sendRequest<string>(AxiosMethod.POST, _url, body, requestOptions);
    }
    aircraftTypesGet( requestOptions?: IAjaxOptions): AxiosPromise<AircraftTypeDto[]> {
        let _url = this.baseUrl + "/api/Aircraft/types";
        return ApiService.sendRequest<AircraftTypeDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    aircraftTypesPost(body: AircraftTypeCreateRequest, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Aircraft/types";
        return ApiService.sendRequest<string>(AxiosMethod.POST, _url, body, requestOptions);
    }
    aircraftTypesGroupsGet( requestOptions?: IAjaxOptions): AxiosPromise<AircraftTypeGroupDto[]> {
        let _url = this.baseUrl + "/api/Aircraft/types/groups";
        return ApiService.sendRequest<AircraftTypeGroupDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    aircraftTypesGroupsPost(body: AircraftTypeGroupCreateRequest, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Aircraft/types/groups";
        return ApiService.sendRequest<string>(AxiosMethod.POST, _url, body, requestOptions);
    }
    aircraftTypesDeletePostById(params?:IDeletePOSTParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Aircraft/types/{id}/delete";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    aircraftTypesGroupsDeletePostById(params?:IDeletePOST2Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Aircraft/types/groups/{id}/delete";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    aircraftNightstopCorrectionPut(body: AircraftTypeNightstopUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Aircraft/nightstop-correction";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    aircraftNightstopCorrectionLogGet(params?:INightstopCorrectionLogParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftNightstopCorrectionLogDto[]> {
        let _url = this.baseUrl + "/api/Aircraft/nightstop-correction-log";
        return ApiService.sendRequest<AircraftNightstopCorrectionLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    aircraftFamilyGet( requestOptions?: IAjaxOptions): AxiosPromise<AircraftFamilyDto[]> {
        let _url = this.baseUrl + "/api/AircraftFamily";
        return ApiService.sendRequest<AircraftFamilyDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    aircraftPantryPantryCodesGet(params?:IPantryCodesParams, requestOptions?: IAjaxOptions): AxiosPromise<CarrierPantryCodeDto[]> {
        let _url = this.baseUrl + "/api/AircraftPantry/pantry-codes";
        return ApiService.sendRequest<CarrierPantryCodeDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    aircraftPantryRowsGet(params?:IRowsAllParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftPantryWeightDto[]> {
        let _url = this.baseUrl + "/api/AircraftPantry/rows";
        return ApiService.sendRequest<AircraftPantryWeightDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    aircraftPantryRowsPut(body: AircraftPantryWeightUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/AircraftPantry/rows";
        return ApiService.sendRequest<string>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    aircraftPantryRowsDelete(params?:IRowsDELETEParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AircraftPantry/rows";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    aircraftPantryRowsDeleteById(params?:IRowsDELETE2Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AircraftPantry/rows/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    aircraftPantryRowsLogGet(params?:IRowsLogParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftPantryWeightLogDto[]> {
        let _url = this.baseUrl + "/api/AircraftPantry/rows-log";
        return ApiService.sendRequest<AircraftPantryWeightLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    aircraftPantryRowsImportPost(aircraftId: string, contentType: string, contentDisposition: string, headers: { [key: string]: string[]; }, length: number, name: string, fileName: string, requestOptions?: IAjaxOptions): AxiosPromise<AircraftPantryWeightImportResult> {
        let _url = this.baseUrl + "/api/AircraftPantry/rows/import";
        return ApiService.sendRequest<AircraftPantryWeightImportResult>(AxiosMethod.POST, _url, fileName, requestOptions);
    }
    airportGet(params?:IAirportParams, requestOptions?: IAjaxOptions): AxiosPromise<AirportDto[]> {
        let _url = this.baseUrl + "/api/Airport";
        return ApiService.sendRequest<AirportDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    airportGridPost(body: AirportsListFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseAirportsListModel> {
        let _url = this.baseUrl + "/api/Airport/grid";
        return ApiService.sendRequest<DevExtremeResponseAirportsListModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    airportHotelDetailsGetByFourLetterCode(params?:IHotelDetailsAllParams, requestOptions?: IAjaxOptions): AxiosPromise<AirportHotelDetailsDto[]> {
        let _url = this.baseUrl + "/api/Airport/{fourLetterCode}/hotel-details";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<AirportHotelDetailsDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    airportHotelDetailsPutByFourLetterCode(fourLetterCode: string, body: AirportHotelDetailsUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Airport/{fourLetterCode}/hotel-details";
        _url = ApiService.getDynamicUrl(_url, { fourLetterCode, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    airportHotelDetailsLogGetByFourLetterCode(params?:IHotelDetailsLogParams, requestOptions?: IAjaxOptions): AxiosPromise<AirportHotelDetailsLogDto[]> {
        let _url = this.baseUrl + "/api/Airport/{fourLetterCode}/hotel-details-log";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<AirportHotelDetailsLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    airportLogGetByFourLetterCode(params?:ILogParams, requestOptions?: IAjaxOptions): AxiosPromise<AirportLogDto[]> {
        let _url = this.baseUrl + "/api/Airport/{fourLetterCode}/log";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<AirportLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    airportSearchGet(params?:ISearchParams, requestOptions?: IAjaxOptions): AxiosPromise<AirportSearchDto[]> {
        let _url = this.baseUrl + "/api/Airport/search";
        return ApiService.sendRequest<AirportSearchDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    airportLookupGet(params?:ILookupAllParams, requestOptions?: IAjaxOptions): AxiosPromise<AirportLookupDto[]> {
        let _url = this.baseUrl + "/api/Airport/lookup";
        return ApiService.sendRequest<AirportLookupDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    airportLookupGetByThreeLetterCode(params?:ILookupParams, requestOptions?: IAjaxOptions): AxiosPromise<AirportLookupDto> {
        let _url = this.baseUrl + "/api/Airport/lookup/{threeLetterCode}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<AirportLookupDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    carrierGet( requestOptions?: IAjaxOptions): AxiosPromise<CarrierDto[]> {
        let _url = this.baseUrl + "/api/Carrier";
        return ApiService.sendRequest<CarrierDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    configurationGet(params?:IConfigurationAllParams, requestOptions?: IAjaxOptions): AxiosPromise<ConfigurationModel[]> {
        let _url = this.baseUrl + "/api/Configuration";
        return ApiService.sendRequest<ConfigurationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    configurationPut(body: ConfigurationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Configuration";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    emailPost(body: EmailFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeEmailViewerGridData> {
        let _url = this.baseUrl + "/api/Email";
        return ApiService.sendRequest<DevExtremeEmailViewerGridData>(AxiosMethod.POST, _url, body, requestOptions);
    }
    emailBodyGet(params?:IBodyParams, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Email/body";
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, params, requestOptions);
    }
    emailAttachmentsGet(params?:IAttachmentsParams, requestOptions?: IAjaxOptions): AxiosPromise<EmailAttachmentDto[]> {
        let _url = this.baseUrl + "/api/Email/attachments";
        return ApiService.sendRequest<EmailAttachmentDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    emailAttachmentGet(params?:IAttachmentParams, requestOptions?: IAjaxOptions): AxiosPromise<File> {
        let _url = this.baseUrl + "/api/Email/attachment";
        return ApiService.sendRequest<File>(AxiosMethod.GET, _url, params, requestOptions);
    }
    emailValidatePost(body: EmailValidateRequest, requestOptions?: IAjaxOptions): AxiosPromise<EmailValidateResponse> {
        let _url = this.baseUrl + "/api/Email/validate";
        return ApiService.sendRequest<EmailValidateResponse>(AxiosMethod.POST, _url, body, requestOptions);
    }
    emailUpdateStatusPostByIdStatus(params?:IUpdateStatusParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Email/update-status/{id}/{status}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    fileExplorerListPost(body: FileExplorerListRequest, requestOptions?: IAjaxOptions): AxiosPromise<FileExplorerListResponse> {
        let _url = this.baseUrl + "/api/FileExplorer/list";
        return ApiService.sendRequest<FileExplorerListResponse>(AxiosMethod.POST, _url, body, requestOptions);
    }
    flightPost(body: FlightsListFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseFlightsListModel> {
        let _url = this.baseUrl + "/api/Flight";
        return ApiService.sendRequest<DevExtremeResponseFlightsListModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    flightGet(params?:IFlightAllParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightDto[]> {
        let _url = this.baseUrl + "/api/Flight";
        return ApiService.sendRequest<FlightDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightFullGet(params?:IFullParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightDto[]> {
        let _url = this.baseUrl + "/api/Flight/full";
        return ApiService.sendRequest<FlightDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightLegacyGet(params?:ILegacyParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightDto[]> {
        let _url = this.baseUrl + "/api/Flight/legacy";
        return ApiService.sendRequest<FlightDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightEnzianGet(params?:IEnzianParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightDto[]> {
        let _url = this.baseUrl + "/api/Flight/enzian";
        return ApiService.sendRequest<FlightDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightDelaysGetById(params?:IDelaysParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightDelayDto[]> {
        let _url = this.baseUrl + "/api/Flight/{id}/delays";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightDelayDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightCrewGetById(params?:ICrewParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightCrewMemberDto[]> {
        let _url = this.baseUrl + "/api/Flight/{id}/crew";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightCrewMemberDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightWeightGetById(params?:IWeightParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightWeightDto> {
        let _url = this.baseUrl + "/api/Flight/{id}/weight";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightWeightDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightPantryCodesGetById(params?:IPantryCodes2Params, requestOptions?: IAjaxOptions): AxiosPromise<CarrierPantryCodeDto[]> {
        let _url = this.baseUrl + "/api/Flight/{id}/pantry-codes";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<CarrierPantryCodeDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightPantryCodePutById(id: string, body: FlightPantryCodeOverrideUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}/pantry-code";
        _url = ApiService.getDynamicUrl(_url, { id, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    flightWeightInputHistoryGetById(params?:IInputHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightWeightInputLogDto[]> {
        let _url = this.baseUrl + "/api/Flight/{id}/weight/input-history";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightWeightInputLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightCargoPutById(id: string, body: FlightCargoUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}/cargo";
        _url = ApiService.getDynamicUrl(_url, { id, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    flightWeightHistoryGetById(params?:IHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<WeightQueueLogDto[]> {
        let _url = this.baseUrl + "/api/Flight/{id}/weight/history";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<WeightQueueLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightWeightCalculationsGetById(params?:ICalculationsParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightWeightSnapshotDto[]> {
        let _url = this.baseUrl + "/api/Flight/{id}/weight/calculations";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightWeightSnapshotDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightWeightSendStateGetById(params?:ISendStateParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightWeightSendStateDto> {
        let _url = this.baseUrl + "/api/Flight/{id}/weight/send-state";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightWeightSendStateDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightWeightPublishPostById(params?:IPublishParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}/weight/publish";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    flightWeightForceResendPostById(params?:IForceResendParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}/weight/force-resend";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    flightNetlineOpsXmlGetById(params?:INetlineOpsXmlParams, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Flight/{id}/netline-ops-xml";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightEnzianXmlGetById(params?:IEnzianXmlParams, requestOptions?: IAjaxOptions): AxiosPromise<EnzianDutyInfo> {
        let _url = this.baseUrl + "/api/Flight/enzian-xml/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<EnzianDutyInfo>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightSeatSummariesGetById(params?:ISeatSummariesParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightSeatSummariesDto> {
        let _url = this.baseUrl + "/api/Flight/{id}/seat-summaries";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightSeatSummariesDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightSeatSummariesHistoryGetById(params?:IHistory2Params, requestOptions?: IAjaxOptions): AxiosPromise<FlightSeatSummaryLogDto[]> {
        let _url = this.baseUrl + "/api/Flight/{id}/seat-summaries/history";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightSeatSummaryLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightCabinVersionsGetById(params?:ICabinVersionsParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftCabinVersionDto[]> {
        let _url = this.baseUrl + "/api/Flight/{id}/cabin-versions";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<AircraftCabinVersionDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightPostById(id: string, body: FlightUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}";
        _url = ApiService.getDynamicUrl(_url, { id, body });
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    flightPnlEmailPostById(id: string, body: FlightPnlEmailRequest, requestOptions?: IAjaxOptions): AxiosPromise<EmailQueueStateDto> {
        let _url = this.baseUrl + "/api/Flight/{id}/pnl-email";
        _url = ApiService.getDynamicUrl(_url, { id, body });
        return ApiService.sendRequest<EmailQueueStateDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    flightSeatSummariesImportPostById(params?:IImport2Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}/seat-summaries/import";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    flightAircraftGet( requestOptions?: IAjaxOptions): AxiosPromise<AircraftDto[]> {
        let _url = this.baseUrl + "/api/Flight/aircraft";
        return ApiService.sendRequest<AircraftDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    flightAircraftMaintenanceGet(params?:IAircraftMaintenanceParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftMaintenanceDto[]> {
        let _url = this.baseUrl + "/api/Flight/aircraft-maintenance";
        return ApiService.sendRequest<AircraftMaintenanceDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightMessagesGetById(params?:IMessagesParams, requestOptions?: IAjaxOptions): AxiosPromise<MessageHistoryModel[]> {
        let _url = this.baseUrl + "/api/Flight/{id}/messages";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<MessageHistoryModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightRebuildPostById(params?:IRebuildParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}/rebuild";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    flightEnzianResyncPostById(params?:IEnzianResyncParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}/enzian-resync";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    flightPublishPostById(params?:IPublish2Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}/publish";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    flightRepublishPostById(params?:IRepublishParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}/republish";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    flightManualLookupsGet( requestOptions?: IAjaxOptions): AxiosPromise<ManualFlightLookupsDto> {
        let _url = this.baseUrl + "/api/Flight/manual/lookups";
        return ApiService.sendRequest<ManualFlightLookupsDto>(AxiosMethod.GET, _url, null, requestOptions);
    }
    flightManualNextLegGet(params?:INextLegParams, requestOptions?: IAjaxOptions): AxiosPromise<ManualFlightNextLegDto> {
        let _url = this.baseUrl + "/api/Flight/manual/next-leg";
        return ApiService.sendRequest<ManualFlightNextLegDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightManualRouteHintsGet(params?:IRouteHintsParams, requestOptions?: IAjaxOptions): AxiosPromise<ManualFlightHintDto[]> {
        let _url = this.baseUrl + "/api/Flight/manual/route-hints";
        return ApiService.sendRequest<ManualFlightHintDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightManualFlightNumberHintsGet(params?:IFlightNumberHintsParams, requestOptions?: IAjaxOptions): AxiosPromise<ManualFlightHintDto[]> {
        let _url = this.baseUrl + "/api/Flight/manual/flight-number-hints";
        return ApiService.sendRequest<ManualFlightHintDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightManualConfigurationHintGet(params?:IConfigurationHintParams, requestOptions?: IAjaxOptions): AxiosPromise<ManualFlightConfigurationHintDto> {
        let _url = this.baseUrl + "/api/Flight/manual/configuration-hint";
        return ApiService.sendRequest<ManualFlightConfigurationHintDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightManualGetById(params?:IManualGETParams, requestOptions?: IAjaxOptions): AxiosPromise<ManualFlightDto> {
        let _url = this.baseUrl + "/api/Flight/{id}/manual";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<ManualFlightDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightManualPutById(id: string, body: ManualFlightUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}/manual";
        _url = ApiService.getDynamicUrl(_url, { id, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    flightManualPost(body: ManualFlightCreateRequest, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Flight/manual";
        return ApiService.sendRequest<string>(AxiosMethod.POST, _url, body, requestOptions);
    }
    flightManualCancelPostById(params?:ICancelParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/{id}/manual/cancel";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    jobListGet( requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobList> {
        let _url = this.baseUrl + "/api/Job/list";
        return ApiService.sendRequest<ApiV1JobList>(AxiosMethod.GET, _url, null, requestOptions);
    }
    jobStartPostByJobName(jobName: string, body: JobStartModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobTrigger> {
        let _url = this.baseUrl + "/api/Job/start/{jobName}";
        _url = ApiService.getDynamicUrl(_url, { jobName, body });
        return ApiService.sendRequest<ApiV1JobTrigger>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobParametersGetByJobName(params?:IParametersGETParams, requestOptions?: IAjaxOptions): AxiosPromise<JobDetailsModel> {
        let _url = this.baseUrl + "/api/Job/parameters/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<JobDetailsModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jobCronValidationPostByCronExpression(params?:IValidationParams, requestOptions?: IAjaxOptions): AxiosPromise<CronValidationResult> {
        let _url = this.baseUrl + "/api/Job/cron/validation/{cronExpression}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<CronValidationResult>(AxiosMethod.POST, _url, params, requestOptions);
    }
    jobParametersPostByTriggerName(triggerName: string, body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/parameters/{triggerName}";
        _url = ApiService.getDynamicUrl(_url, { triggerName, body });
        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobSettingsPostByJobName(jobName: string, body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/settings/{jobName}";
        _url = ApiService.getDynamicUrl(_url, { jobName, body });
        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobCreatePost(body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/create";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobDeleteDelete(params?:IDeleteDELETEParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/delete";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    jobStopPostByJobName(params?:IStopParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/stop/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    jobCheckTriggerNameGet(params?:ICheckTriggerNameParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/check-trigger-name";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    pantryCarrierCodesGet(params?:ICarrierCodesParams, requestOptions?: IAjaxOptions): AxiosPromise<CarrierPantryCodeDto[]> {
        let _url = this.baseUrl + "/api/Pantry/carrier-codes";
        return ApiService.sendRequest<CarrierPantryCodeDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    pantryStationCodesGet(params?:IStationCodesAllParams, requestOptions?: IAjaxOptions): AxiosPromise<StationPantryCodeDto[]> {
        let _url = this.baseUrl + "/api/Pantry/station-codes";
        return ApiService.sendRequest<StationPantryCodeDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    pantryStationCodesPut(body: StationPantryCodeUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Pantry/station-codes";
        return ApiService.sendRequest<string>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    pantryStationCodeLogGet(params?:IStationCodeLogParams, requestOptions?: IAjaxOptions): AxiosPromise<StationPantryCodeLogDto[]> {
        let _url = this.baseUrl + "/api/Pantry/station-code-log";
        return ApiService.sendRequest<StationPantryCodeLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    pantryFutureDestinationPantryStatusGet( requestOptions?: IAjaxOptions): AxiosPromise<PantryCompletenessDto> {
        let _url = this.baseUrl + "/api/Pantry/future-destination-pantry-status";
        return ApiService.sendRequest<PantryCompletenessDto>(AxiosMethod.GET, _url, null, requestOptions);
    }
    pantryStationCodesImportPost(contentType: string, contentDisposition: string, headers: { [key: string]: string[]; }, length: number, name: string, fileName: string, removeExtraData: boolean, dryRun: boolean, requestOptions?: IAjaxOptions): AxiosPromise<ExcelImportProgressDto[]> {
        let _url = this.baseUrl + "/api/Pantry/station-codes/import";
        return ApiService.sendRequest<ExcelImportProgressDto[]>(AxiosMethod.POST, _url, dryRun, requestOptions);
    }
    peopleAssistIllnessPersonsPost(body: PeopleAssistIllnessFilter, requestOptions?: IAjaxOptions): AxiosPromise<PeopleAssistIllnessPersonGridData> {
        let _url = this.baseUrl + "/api/PeopleAssist/illness/persons";
        return ApiService.sendRequest<PeopleAssistIllnessPersonGridData>(AxiosMethod.POST, _url, body, requestOptions);
    }
    peopleAssistIllnessPersonsGetByPersonCode(params?:IPersonsGETParams, requestOptions?: IAjaxOptions): AxiosPromise<PeopleAssistIllnessPersonDetailDto> {
        let _url = this.baseUrl + "/api/PeopleAssist/illness/persons/{personCode}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PeopleAssistIllnessPersonDetailDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    peopleAssistIllnessPersonsLiveGetByPersonCode(params?:ILiveParams, requestOptions?: IAjaxOptions): AxiosPromise<PeopleAssistIllnessLiveFormDto[]> {
        let _url = this.baseUrl + "/api/PeopleAssist/illness/persons/{personCode}/live";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PeopleAssistIllnessLiveFormDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    peopleAssistEntriesPost(body: PeopleAssistFilter, requestOptions?: IAjaxOptions): AxiosPromise<PeopleAssistEntryGridData> {
        let _url = this.baseUrl + "/api/PeopleAssist/entries";
        return ApiService.sendRequest<PeopleAssistEntryGridData>(AxiosMethod.POST, _url, body, requestOptions);
    }
    peopleAssistEntriesGetByKindId(params?:IEntriesGETParams, requestOptions?: IAjaxOptions): AxiosPromise<PeopleAssistEntryDetailDto> {
        let _url = this.baseUrl + "/api/PeopleAssist/entries/{kind}/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PeopleAssistEntryDetailDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    peopleAssistLiveFormsPost(body: PeopleAssistLiveFilter, requestOptions?: IAjaxOptions): AxiosPromise<PeopleAssistLiveFormsResult> {
        let _url = this.baseUrl + "/api/PeopleAssist/live/forms";
        return ApiService.sendRequest<PeopleAssistLiveFormsResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    peopleAssistLiveFormsGetById(params?:IFormsGETParams, requestOptions?: IAjaxOptions): AxiosPromise<PeopleAssistLiveFormDetailDto> {
        let _url = this.baseUrl + "/api/PeopleAssist/live/forms/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PeopleAssistLiveFormDetailDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    peopleAssistLiveFormsByNumberGetByNumber(params?:IByNumberParams, requestOptions?: IAjaxOptions): AxiosPromise<PeopleAssistLiveFormDetailDto> {
        let _url = this.baseUrl + "/api/PeopleAssist/live/forms/by-number/{number}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PeopleAssistLiveFormDetailDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    peopleAssistOptionsFormsGet( requestOptions?: IAjaxOptions): AxiosPromise<JobParameterOptionsModel> {
        let _url = this.baseUrl + "/api/PeopleAssist/options/forms";
        return ApiService.sendRequest<JobParameterOptionsModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    peopleAssistOptionsMacrosGet( requestOptions?: IAjaxOptions): AxiosPromise<JobParameterOptionsModel> {
        let _url = this.baseUrl + "/api/PeopleAssist/options/macros";
        return ApiService.sendRequest<JobParameterOptionsModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    peopleAssistOptionsCustomStatusGet( requestOptions?: IAjaxOptions): AxiosPromise<JobParameterOptionsModel> {
        let _url = this.baseUrl + "/api/PeopleAssist/options/custom-status";
        return ApiService.sendRequest<JobParameterOptionsModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    peopleAssistOptionsEmployeesGet(params?:IEmployeesParams, requestOptions?: IAjaxOptions): AxiosPromise<JobParameterOptionsModel> {
        let _url = this.baseUrl + "/api/PeopleAssist/options/employees";
        return ApiService.sendRequest<JobParameterOptionsModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    permissionGet( requestOptions?: IAjaxOptions): AxiosPromise<PermissionModel[]> {
        let _url = this.baseUrl + "/api/Permission";
        return ApiService.sendRequest<PermissionModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    permissionRoleGet( requestOptions?: IAjaxOptions): AxiosPromise<PredefinedRoleModel[]> {
        let _url = this.baseUrl + "/api/Permission/role";
        return ApiService.sendRequest<PredefinedRoleModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    permissionRoleGetByRoleId(params?:IRole2Params, requestOptions?: IAjaxOptions): AxiosPromise<PermissionModel[]> {
        let _url = this.baseUrl + "/api/Permission/role/{roleId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PermissionModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    monitoringGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult[]> {
        let _url = this.baseUrl + "/api/monitoring";
        return ApiService.sendRequest<SelfTestResult[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    monitoringJobGetByJobName(params?:IJobParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/monitoring/job/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    selfTestJobsPost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/jobs";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    monitoringJobsGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/monitoring/jobs";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.GET, _url, null, requestOptions);
    }
    selfTestMessagebusPost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/messagebus";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    monitoringMessagebusGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/monitoring/messagebus";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.GET, _url, null, requestOptions);
    }
    selfTestMessageTypeHealthGet(params?:IMessageTypeHealthParams, requestOptions?: IAjaxOptions): AxiosPromise<ServiceBusMessageTypeHealthModel[]> {
        let _url = this.baseUrl + "/api/SelfTest/message-type-health";
        return ApiService.sendRequest<ServiceBusMessageTypeHealthModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    selfTestIntegrationHealthGet( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/SelfTest/integration-health";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, null, requestOptions);
    }
    selfTestFlightEnzianChangesQueuePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/flight-enzian-changes-queue";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    selfTestAirportQueuePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/airport-queue";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    selfTestWeightQueuePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/weight-queue";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    selfTestDatabasePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/database";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    monitoringDatabaseGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/monitoring/database";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.GET, _url, null, requestOptions);
    }
    selfTestUpdateDatabasePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/update-database";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    serviceDownloadMessagesGet(params?:IDownloadMessagesParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-messages";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceMessageLabelsGet(params?:IMessageLabelsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/message-labels";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceMessageTagsGet(params?:IMessageTagsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/message-tags";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceMessagesDatesGet( requestOptions?: IAjaxOptions): AxiosPromise<Date[]> {
        let _url = this.baseUrl + "/api/Service/messages-dates";
        return ApiService.sendRequest<Date[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    serviceDownloadSapImportsGet(params?:IDownloadSapImportsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-sap-imports";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceDownloadSapExportsGet(params?:IDownloadSapExportsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-sap-exports";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceSapImportDatesGet( requestOptions?: IAjaxOptions): AxiosPromise<Date[]> {
        let _url = this.baseUrl + "/api/Service/sap-import-dates";
        return ApiService.sendRequest<Date[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    serviceSapExportDatesGet( requestOptions?: IAjaxOptions): AxiosPromise<Date[]> {
        let _url = this.baseUrl + "/api/Service/sap-export-dates";
        return ApiService.sendRequest<Date[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    serviceDownloadDeadlettersGet(params?:IDownloadDeadlettersParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-deadletters";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceDatesGet( requestOptions?: IAjaxOptions): AxiosPromise<Date[]> {
        let _url = this.baseUrl + "/api/Service/dates";
        return ApiService.sendRequest<Date[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    serviceLogFilesGet(params?:ILogFilesParams, requestOptions?: IAjaxOptions): AxiosPromise<LogFileListItemModel[]> {
        let _url = this.baseUrl + "/api/Service/log-files";
        return ApiService.sendRequest<LogFileListItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceDownloadLogGet(params?:IDownloadLogParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-log";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceDownloadLogGzGet(params?:IDownloadLogGzParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-log-gz";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceLogFileDelete(params?:ILogFileParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/log-file";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    serviceMessageStatisticsGet(params?:IMessageStatisticsParams, requestOptions?: IAjaxOptions): AxiosPromise<MessageStatisticsModel[]> {
        let _url = this.baseUrl + "/api/Service/message-statistics";
        return ApiService.sendRequest<MessageStatisticsModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceRestartSchedulerPost( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/restart-scheduler";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, null, requestOptions);
    }
    serviceInputQueueStatisticsPost(body: InputQueueStatisticsRequestModel, requestOptions?: IAjaxOptions): AxiosPromise<QueueStatisticsModel[]> {
        let _url = this.baseUrl + "/api/Service/input-queue-statistics";
        return ApiService.sendRequest<QueueStatisticsModel[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    serviceQueueNamesGet( requestOptions?: IAjaxOptions): AxiosPromise<QueueModel[]> {
        let _url = this.baseUrl + "/api/Service/queue-names";
        return ApiService.sendRequest<QueueModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    serviceInputQueueDeadlettersPost(body: InputQueueDeadlettersRequestModel, requestOptions?: IAjaxOptions): AxiosPromise<DeadletterPageModel> {
        let _url = this.baseUrl + "/api/Service/input-queue-deadletters";
        return ApiService.sendRequest<DeadletterPageModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    serviceInputQueueDeadlettersDelete(params?:IInputQueueDeadlettersDELETEParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/input-queue-deadletters";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    signalRUserGet( requestOptions?: IAjaxOptions): AxiosPromise<ConnectedClientModel[]> {
        let _url = this.baseUrl + "/api/SignalRUser";
        return ApiService.sendRequest<ConnectedClientModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    waterCorrectionRowsGet(params?:IRowsAll2Params, requestOptions?: IAjaxOptions): AxiosPromise<WaterQuantityWeightCorrectionDto[]> {
        let _url = this.baseUrl + "/api/WaterCorrection/rows";
        return ApiService.sendRequest<WaterQuantityWeightCorrectionDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    waterCorrectionRowsPut(body: WaterQuantityWeightCorrectionUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/WaterCorrection/rows";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    waterCorrectionRowsDeleteByAircraftIdWaterLevel(params?:IRowsDELETE3Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/WaterCorrection/rows/{aircraftId}/{waterLevel}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    waterCorrectionRowsLogGet(params?:IRowsLog2Params, requestOptions?: IAjaxOptions): AxiosPromise<WaterQuantityWeightCorrectionLogDto[]> {
        let _url = this.baseUrl + "/api/WaterCorrection/rows-log";
        return ApiService.sendRequest<WaterQuantityWeightCorrectionLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    waterQuantityAircraftTypeGroupsGet(params?:IAircraftTypeGroupsParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftTypeGroupDto[]> {
        let _url = this.baseUrl + "/api/WaterQuantity/aircraft-type-groups";
        return ApiService.sendRequest<AircraftTypeGroupDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    waterQuantityStationLegsGet(params?:IStationLegsAllParams, requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/WaterQuantity/station-legs";
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    waterQuantityStationLegsPost(params?:IStationLegsPOSTParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/WaterQuantity/station-legs";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    waterQuantityStationLegsDelete(params?:IStationLegsDELETEParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/WaterQuantity/station-legs";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    waterQuantityStationLegQuantitiesGet(params?:IStationLegQuantitiesAllParams, requestOptions?: IAjaxOptions): AxiosPromise<StationWaterQuantityLegDto[]> {
        let _url = this.baseUrl + "/api/WaterQuantity/station-leg-quantities";
        return ApiService.sendRequest<StationWaterQuantityLegDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    waterQuantityStationLegQuantitiesPut(body: StationWaterQuantityLegUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/WaterQuantity/station-leg-quantities";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    waterQuantityStationNoWaterUpliftPut(body: AirportNoWaterUpliftUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/WaterQuantity/station-no-water-uplift";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    waterQuantityStationLegQuantityLogGet(params?:IStationLegQuantityLogParams, requestOptions?: IAjaxOptions): AxiosPromise<StationWaterQuantityLegLogDto[]> {
        let _url = this.baseUrl + "/api/WaterQuantity/station-leg-quantity-log";
        return ApiService.sendRequest<StationWaterQuantityLegLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    waterQuantityFutureFlightWaterQuantityStatusGet( requestOptions?: IAjaxOptions): AxiosPromise<WaterQuantityCompletenessDto> {
        let _url = this.baseUrl + "/api/WaterQuantity/future-flight-water-quantity-status";
        return ApiService.sendRequest<WaterQuantityCompletenessDto>(AxiosMethod.GET, _url, null, requestOptions);
    }
    waterQuantityImportPost(contentType: string, contentDisposition: string, headers: { [key: string]: string[]; }, length: number, name: string, fileName: string, removeExtraData: boolean, dryRun: boolean, requestOptions?: IAjaxOptions): AxiosPromise<ExcelImportProgressDto[]> {
        let _url = this.baseUrl + "/api/WaterQuantity/import";
        return ApiService.sendRequest<ExcelImportProgressDto[]>(AxiosMethod.POST, _url, dryRun, requestOptions);
    }
}
export enum AbsenceBlockStatus {
    Created = "Created",
    Updated = "Updated",
    Deleted = "Deleted",
}

export interface IAircraftCabinVersionDto {
    id: string;
    seatsC: number;
    seatsE: number;
    seatsY: number;
}
export class AircraftCabinVersionDto extends BaseApiModelClass< IAircraftCabinVersionDto > implements IAircraftCabinVersionDto {
    id: string;
    seatsC: number;
    seatsE: number;
    seatsY: number;
}

export interface IAircraftCreateRequest {
    registrationNumber: string;
    aircraftTypeId: string;
    airlineRcd: string;
    inServiceDateFrom: Date;
    inServiceDateTo?: Date;
    dateOfManufacture?: Date;
    msn?: string;
    flightHoursBeginEdw?: number;
    cyclesBeginEdw?: number;
}
export class AircraftCreateRequest extends BaseApiModelClass< IAircraftCreateRequest > implements IAircraftCreateRequest {
    registrationNumber: string;
    aircraftTypeId: string;
    airlineRcd: string;
    inServiceDateFrom: Date;
    inServiceDateTo?: Date;
    dateOfManufacture?: Date;
    msn?: string;
    flightHoursBeginEdw?: number;
    cyclesBeginEdw?: number;
}

export interface IAircraftDto {
    id: string;
    registrationNumber: string;
    aircraftTypeRcd: string;
    aircraftTypeGroupName?: string;
    airlineRcd?: string;
    inServiceDateFrom: Date;
    inServiceDateTo?: Date;
    dateOfManufacture?: Date;
    msn?: string;
    flightHoursBeginEdw?: number;
    cyclesBeginEdw?: number;
    nightstopDomCorrection?: number;
    nightstopDoiCorrection?: number;
}
export class AircraftDto extends BaseApiModelClass< IAircraftDto > implements IAircraftDto {
    id: string;
    registrationNumber: string;
    aircraftTypeRcd: string;
    aircraftTypeGroupName?: string;
    airlineRcd?: string;
    inServiceDateFrom: Date;
    inServiceDateTo?: Date;
    dateOfManufacture?: Date;
    msn?: string;
    flightHoursBeginEdw?: number;
    cyclesBeginEdw?: number;
    nightstopDomCorrection?: number;
    nightstopDoiCorrection?: number;
}

export interface IAircraftFamilyDto {
    id: string;
    name?: string;
}
export class AircraftFamilyDto extends BaseApiModelClass< IAircraftFamilyDto > implements IAircraftFamilyDto {
    id: string;
    name?: string;
}

export interface IAircraftMaintenanceDto {
    id: string;
    aircraftId?: string;
    aircraftTypeRcd?: string;
    dateTimeFromUtc: Date;
    dateTimeToUtc: Date;
    title: string;
    isServiceFlight: boolean;
}
export class AircraftMaintenanceDto extends BaseApiModelClass< IAircraftMaintenanceDto > implements IAircraftMaintenanceDto {
    id: string;
    aircraftId?: string;
    aircraftTypeRcd?: string;
    dateTimeFromUtc: Date;
    dateTimeToUtc: Date;
    title: string;
    isServiceFlight: boolean;
}

export interface IAircraftNightstopCorrectionLogDto {
    id: string;
    aircraftTypeGroupId: string;
    nightstopDomCorrection?: number;
    nightstopDoiCorrection?: number;
    action: AuditAction;
    timestamp: Date;
    changedBy?: string;
}
export class AircraftNightstopCorrectionLogDto extends BaseApiModelClass< IAircraftNightstopCorrectionLogDto > implements IAircraftNightstopCorrectionLogDto {
    id: string;
    aircraftTypeGroupId: string;
    nightstopDomCorrection?: number;
    nightstopDoiCorrection?: number;
    action: AuditAction;
    timestamp: Date;
    changedBy?: string;
}

export interface IAircraftPantryWeightDto {
    id: string;
    aircraftId: string;
    pantryCode: string;
    pantryCodeName?: string;
    cockpitCrewCount: number;
    cabinCrewCount: number;
    dom: number;
    doi: number;
}
export class AircraftPantryWeightDto extends BaseApiModelClass< IAircraftPantryWeightDto > implements IAircraftPantryWeightDto {
    id: string;
    aircraftId: string;
    pantryCode: string;
    pantryCodeName?: string;
    cockpitCrewCount: number;
    cabinCrewCount: number;
    dom: number;
    doi: number;
}

export interface IAircraftPantryWeightImportResult {
    createdCount: number;
    updatedCount: number;
    deletedCount: number;
    errors?: AircraftPantryWeightImportRowResult[];
}
export class AircraftPantryWeightImportResult extends BaseApiModelClass< IAircraftPantryWeightImportResult > implements IAircraftPantryWeightImportResult {
    createdCount: number;
    updatedCount: number;
    deletedCount: number;
    errors?: AircraftPantryWeightImportRowResult[];
}

export interface IAircraftPantryWeightImportRowResult {
    rowNumber: number;
    error?: string;
}
export class AircraftPantryWeightImportRowResult extends BaseApiModelClass< IAircraftPantryWeightImportRowResult > implements IAircraftPantryWeightImportRowResult {
    rowNumber: number;
    error?: string;
}

export interface IAircraftPantryWeightLogDto {
    id: string;
    aircraftId: string;
    pantryCodeName?: string;
    cockpitCrewCount: number;
    cabinCrewCount: number;
    dom: number;
    doi: number;
    action?: string;
    timestamp: Date;
    changedBy?: string;
}
export class AircraftPantryWeightLogDto extends BaseApiModelClass< IAircraftPantryWeightLogDto > implements IAircraftPantryWeightLogDto {
    id: string;
    aircraftId: string;
    pantryCodeName?: string;
    cockpitCrewCount: number;
    cabinCrewCount: number;
    dom: number;
    doi: number;
    action?: string;
    timestamp: Date;
    changedBy?: string;
}

export interface IAircraftPantryWeightUpdateRequest {
    id?: string;
    aircraftId: string;
    pantryCode: string;
    cockpitCrewCount: number;
    cabinCrewCount: number;
    dom: number;
    doi: number;
}
export class AircraftPantryWeightUpdateRequest extends BaseApiModelClass< IAircraftPantryWeightUpdateRequest > implements IAircraftPantryWeightUpdateRequest {
    id?: string;
    aircraftId: string;
    pantryCode: string;
    cockpitCrewCount: number;
    cabinCrewCount: number;
    dom: number;
    doi: number;
}

export interface IAircraftTypeCreateRequest {
    codeName: string;
    aircraftTypeGroupId?: string;
    newTypeGroupName?: string;
}
export class AircraftTypeCreateRequest extends BaseApiModelClass< IAircraftTypeCreateRequest > implements IAircraftTypeCreateRequest {
    codeName: string;
    aircraftTypeGroupId?: string;
    newTypeGroupName?: string;
}

export interface IAircraftTypeDto {
    id: string;
    codeName?: string;
}
export class AircraftTypeDto extends BaseApiModelClass< IAircraftTypeDto > implements IAircraftTypeDto {
    id: string;
    codeName?: string;
}

export interface IAircraftTypeGroupCreateRequest {
    name: string;
    isActive: boolean;
}
export class AircraftTypeGroupCreateRequest extends BaseApiModelClass< IAircraftTypeGroupCreateRequest > implements IAircraftTypeGroupCreateRequest {
    name: string;
    isActive: boolean;
}

export interface IAircraftTypeGroupDto {
    id: string;
    name?: string;
    isActive: boolean;
}
export class AircraftTypeGroupDto extends BaseApiModelClass< IAircraftTypeGroupDto > implements IAircraftTypeGroupDto {
    id: string;
    name?: string;
    isActive: boolean;
}

export interface IAircraftTypeNightstopUpdateRequest {
    aircraftId: string;
    nightstopDomCorrection?: number;
    nightstopDoiCorrection?: number;
}
export class AircraftTypeNightstopUpdateRequest extends BaseApiModelClass< IAircraftTypeNightstopUpdateRequest > implements IAircraftTypeNightstopUpdateRequest {
    aircraftId: string;
    nightstopDomCorrection?: number;
    nightstopDoiCorrection?: number;
}

export interface IAircraftUpdateRequest {
    id: string;
    inServiceDateFrom: Date;
    inServiceDateTo?: Date;
    dateOfManufacture?: Date;
    msn?: string;
    flightHoursBeginEdw?: number;
    cyclesBeginEdw?: number;
}
export class AircraftUpdateRequest extends BaseApiModelClass< IAircraftUpdateRequest > implements IAircraftUpdateRequest {
    id: string;
    inServiceDateFrom: Date;
    inServiceDateTo?: Date;
    dateOfManufacture?: Date;
    msn?: string;
    flightHoursBeginEdw?: number;
    cyclesBeginEdw?: number;
}

export interface IAirportDto {
    fourLetterCode?: string;
    threeLetterCode?: string;
    name?: string;
    countryCode?: string;
    isDisabled: boolean;
    location: LocationDto;
    timestamp: Date;
    stationManager: StationManagerDto;
    countryName?: string;
    countryRegion?: string;
    countrySubRegion?: string;
    countryIntermediateRegion?: string;
    isRelevant: boolean;
    noWaterUplift: boolean;
}
export class AirportDto extends BaseApiModelClass< IAirportDto > implements IAirportDto {
    fourLetterCode?: string;
    threeLetterCode?: string;
    name?: string;
    countryCode?: string;
    isDisabled: boolean;
    location: LocationDto;
    timestamp: Date;
    stationManager: StationManagerDto;
    countryName?: string;
    countryRegion?: string;
    countrySubRegion?: string;
    countryIntermediateRegion?: string;
    isRelevant: boolean;
    noWaterUplift: boolean;
}

export interface IAirportGridDto {
    fourLetterCode?: string;
    threeLetterCode?: string;
    name?: string;
    countryCode?: string;
    isDisabled: boolean;
    location: LocationDto;
    timestamp: Date;
    stationManager: StationManagerDto;
    countryName?: string;
    countryRegion?: string;
    countrySubRegion?: string;
    countryIntermediateRegion?: string;
    isRelevant: boolean;
    noWaterUplift: boolean;
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
}
export class AirportGridDto extends BaseApiModelClass< IAirportGridDto > implements IAirportGridDto {
    fourLetterCode?: string;
    threeLetterCode?: string;
    name?: string;
    countryCode?: string;
    isDisabled: boolean;
    location: LocationDto;
    timestamp: Date;
    stationManager: StationManagerDto;
    countryName?: string;
    countryRegion?: string;
    countrySubRegion?: string;
    countryIntermediateRegion?: string;
    isRelevant: boolean;
    noWaterUplift: boolean;
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
}

export interface IAirportGridDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class AirportGridDtoDataSourceLoadOptions extends BaseApiModelClass< IAirportGridDtoDataSourceLoadOptions > implements IAirportGridDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IAirportHotelDetailsDto {
    fourLetterCode?: string;
    detailType: HotelDetailType;
    detailValue?: string;
}
export class AirportHotelDetailsDto extends BaseApiModelClass< IAirportHotelDetailsDto > implements IAirportHotelDetailsDto {
    fourLetterCode?: string;
    detailType: HotelDetailType;
    detailValue?: string;
}

export interface IAirportHotelDetailsLogDto {
    id: string;
    fourLetterCode?: string;
    detailType: HotelDetailType;
    oldDetailValue?: string;
    newDetailValue?: string;
    changedAtUtc: Date;
    changedBy?: string;
    isEnzianSync: boolean;
}
export class AirportHotelDetailsLogDto extends BaseApiModelClass< IAirportHotelDetailsLogDto > implements IAirportHotelDetailsLogDto {
    id: string;
    fourLetterCode?: string;
    detailType: HotelDetailType;
    oldDetailValue?: string;
    newDetailValue?: string;
    changedAtUtc: Date;
    changedBy?: string;
    isEnzianSync: boolean;
}

export interface IAirportHotelDetailsUpdateRequest {
    details?: AirportHotelDetailsDto[];
}
export class AirportHotelDetailsUpdateRequest extends BaseApiModelClass< IAirportHotelDetailsUpdateRequest > implements IAirportHotelDetailsUpdateRequest {
    details?: AirportHotelDetailsDto[];
}

export interface IAirportLogDto {
    changedAtUtc: Date;
    changedBy?: string;
    oldNoWaterUplift?: boolean;
    newNoWaterUplift?: boolean;
    oldIsLongHaulOverride?: boolean;
    newIsLongHaulOverride?: boolean;
}
export class AirportLogDto extends BaseApiModelClass< IAirportLogDto > implements IAirportLogDto {
    changedAtUtc: Date;
    changedBy?: string;
    oldNoWaterUplift?: boolean;
    newNoWaterUplift?: boolean;
    oldIsLongHaulOverride?: boolean;
    newIsLongHaulOverride?: boolean;
}

export interface IAirportLookupDto {
    threeLetterCode?: string;
    fourLetterCode?: string;
    name?: string;
    isActive: boolean;
}
export class AirportLookupDto extends BaseApiModelClass< IAirportLookupDto > implements IAirportLookupDto {
    threeLetterCode?: string;
    fourLetterCode?: string;
    name?: string;
    isActive: boolean;
}

export interface IAirportNoWaterUpliftUpdateRequest {
    fourLetterCode?: string;
    noWaterUplift: boolean;
}
export class AirportNoWaterUpliftUpdateRequest extends BaseApiModelClass< IAirportNoWaterUpliftUpdateRequest > implements IAirportNoWaterUpliftUpdateRequest {
    fourLetterCode?: string;
    noWaterUplift: boolean;
}

export interface IAirportSearchDto {
    value?: string;
    label?: string;
}
export class AirportSearchDto extends BaseApiModelClass< IAirportSearchDto > implements IAirportSearchDto {
    value?: string;
    label?: string;
}

export interface IAirportsListFilter {
    rowLimit?: number;
    includeAll: boolean;
}
export class AirportsListFilter extends BaseApiModelClass< IAirportsListFilter > implements IAirportsListFilter {
    rowLimit?: number;
    includeAll: boolean;
}

export interface IApiErrorResponse {
    errorMessage?: string;
}
export class ApiErrorResponse extends BaseApiModelClass< IApiErrorResponse > implements IApiErrorResponse {
    errorMessage?: string;
}

export interface IApiV1Job {
    id?: string;
    name?: string;
    description?: string;
    jobType?: string;
    instance?: string;
    lastRunDateTimeUtc?: Date;
    nextRunDateTimeUtc?: Date;
    lastRunTriggerName?: string;
    nextRunTriggerName?: string;
    lastErrorMessage?: string;
    lastStatus: JobStatus;
    lastExecutionInfoMessage?: string;
    parameters?: JobParameterDescriptionModel[];
    timestampDateTimeUtc: Date;
    triggers?: JobTriggerShortInfo[];
}
export class ApiV1Job extends BaseApiModelClass< IApiV1Job > implements IApiV1Job {
    id?: string;
    name?: string;
    description?: string;
    jobType?: string;
    instance?: string;
    lastRunDateTimeUtc?: Date;
    nextRunDateTimeUtc?: Date;
    lastRunTriggerName?: string;
    nextRunTriggerName?: string;
    lastErrorMessage?: string;
    lastStatus: JobStatus;
    lastExecutionInfoMessage?: string;
    parameters?: JobParameterDescriptionModel[];
    timestampDateTimeUtc: Date;
    triggers?: JobTriggerShortInfo[];
}

export interface IApiV1JobList {
    jobs?: ApiV1Job[];
    status: SchedulerStatus;
    startupException?: string;
}
export class ApiV1JobList extends BaseApiModelClass< IApiV1JobList > implements IApiV1JobList {
    jobs?: ApiV1Job[];
    status: SchedulerStatus;
    startupException?: string;
}

export interface IApiV1JobTrigger {
    executionId?: string;
    id?: string;
    lastRunDateTime?: Date;
    status: JobStatus;
    isActive: boolean;
}
export class ApiV1JobTrigger extends BaseApiModelClass< IApiV1JobTrigger > implements IApiV1JobTrigger {
    executionId?: string;
    id?: string;
    lastRunDateTime?: Date;
    status: JobStatus;
    isActive: boolean;
}

export enum AuditAction {
    Created = "Created",
    Updated = "Updated",
    Deleted = "Deleted",
}

export interface ICarrierDto {
    code?: string;
    name?: string;
    sortOrder: number;
}
export class CarrierDto extends BaseApiModelClass< ICarrierDto > implements ICarrierDto {
    code?: string;
    name?: string;
    sortOrder: number;
}

export interface ICarrierPantryCodeDto {
    id: string;
    carrierCode?: string;
    aircraftFamilyId: string;
    pantryCode?: string;
    description?: string;
    sortOrder: number;
}
export class CarrierPantryCodeDto extends BaseApiModelClass< ICarrierPantryCodeDto > implements ICarrierPantryCodeDto {
    id: string;
    carrierCode?: string;
    aircraftFamilyId: string;
    pantryCode?: string;
    description?: string;
    sortOrder: number;
}

export enum ConfigType {
    Text = "Text",
    Boolean = "Boolean",
    Select = "Select",
    Uri = "Uri",
    Html = "Html",
    Number = "Number",
    Date = "Date",
    DateTime = "DateTime",
}

export interface IConfigurationModel {
    key?: string;
    group?: string;
    value?: string;
    description?: string;
    type: ConfigType;
    isSystem?: boolean;
    options?: string;
    permission?: string;
}
export class ConfigurationModel extends BaseApiModelClass< IConfigurationModel > implements IConfigurationModel {
    key?: string;
    group?: string;
    value?: string;
    description?: string;
    type: ConfigType;
    isSystem?: boolean;
    options?: string;
    permission?: string;
}

export interface IConnectedClientModel {
    identity?: string;
    fullName?: string;
    count: number;
}
export class ConnectedClientModel extends BaseApiModelClass< IConnectedClientModel > implements IConnectedClientModel {
    identity?: string;
    fullName?: string;
    count: number;
}

export interface ICronValidationResult {
    isValid: boolean;
    validationErrorMessage?: string;
    expressionSummary?: string;
    nextInvalidTime?: Date;
}
export class CronValidationResult extends BaseApiModelClass< ICronValidationResult > implements ICronValidationResult {
    isValid: boolean;
    validationErrorMessage?: string;
    expressionSummary?: string;
    nextInvalidTime?: Date;
}

export interface IDeadletterInfoModel {
    id: string;
    label: MessageLabel;
    message?: string;
    error?: string;
}
export class DeadletterInfoModel extends BaseApiModelClass< IDeadletterInfoModel > implements IDeadletterInfoModel {
    id: string;
    label: MessageLabel;
    message?: string;
    error?: string;
}

export interface IDeadletterPageModel {
    items?: DeadletterInfoModel[];
    nextSequenceNumber?: number;
    totalCount?: number;
}
export class DeadletterPageModel extends BaseApiModelClass< IDeadletterPageModel > implements IDeadletterPageModel {
    items?: DeadletterInfoModel[];
    nextSequenceNumber?: number;
    totalCount?: number;
}

export interface IDevExtremeEmailViewerGridData {
    data?: DevExtremeEmailViewerItemData[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeEmailViewerGridData extends BaseApiModelClass< IDevExtremeEmailViewerGridData > implements IDevExtremeEmailViewerGridData {
    data?: DevExtremeEmailViewerItemData[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeEmailViewerItemData {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    createdDate: Date;
    sentDate?: Date;
    from?: string;
    to?: string;
    subject?: string;
    bodyContentType?: string;
    cc?: string;
    bcc?: string;
    type: MailQueueType;
    label?: string;
    status: MailQueueStatus;
    hasAttachments: boolean;
    errorMessage?: string;
}
export class DevExtremeEmailViewerItemData extends BaseApiModelClass< IDevExtremeEmailViewerItemData > implements IDevExtremeEmailViewerItemData {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    createdDate: Date;
    sentDate?: Date;
    from?: string;
    to?: string;
    subject?: string;
    bodyContentType?: string;
    cc?: string;
    bcc?: string;
    type: MailQueueType;
    label?: string;
    status: MailQueueStatus;
    hasAttachments: boolean;
    errorMessage?: string;
}

export interface IDevExtremeEmailViewerItemDataDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class DevExtremeEmailViewerItemDataDataSourceLoadOptions extends BaseApiModelClass< IDevExtremeEmailViewerItemDataDataSourceLoadOptions > implements IDevExtremeEmailViewerItemDataDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IDevExtremeResponseAirportsListModel {
    data?: AirportGridDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseAirportsListModel extends BaseApiModelClass< IDevExtremeResponseAirportsListModel > implements IDevExtremeResponseAirportsListModel {
    data?: AirportGridDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseFlightsListModel {
    data?: FlightGridDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseFlightsListModel extends BaseApiModelClass< IDevExtremeResponseFlightsListModel > implements IDevExtremeResponseFlightsListModel {
    data?: FlightGridDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IEmailAttachmentDto {
    id: string;
    name?: string;
    type: EmailContentType;
    size?: number;
}
export class EmailAttachmentDto extends BaseApiModelClass< IEmailAttachmentDto > implements IEmailAttachmentDto {
    id: string;
    name?: string;
    type: EmailContentType;
    size?: number;
}

export enum EmailContentType {
    None = "None",
    Xml = "Xml",
    Pdf = "Pdf",
    Xls = "Xls",
    Xlsx = "Xlsx",
}

export interface IEmailFilter {
    rowLimit?: number;
    periodFrom: Date;
    periodTo?: Date;
    searchTerm?: string;
}
export class EmailFilter extends BaseApiModelClass< IEmailFilter > implements IEmailFilter {
    rowLimit?: number;
    periodFrom: Date;
    periodTo?: Date;
    searchTerm?: string;
}

export interface IEmailQueueStateDto {
    status: MailQueueStatus;
    errorMessage?: string;
    queueLength: number;
    lastSentAtUtc?: Date;
}
export class EmailQueueStateDto extends BaseApiModelClass< IEmailQueueStateDto > implements IEmailQueueStateDto {
    status: MailQueueStatus;
    errorMessage?: string;
    queueLength: number;
    lastSentAtUtc?: Date;
}

export interface IEmailValidateRequest {
    value?: string;
}
export class EmailValidateRequest extends BaseApiModelClass< IEmailValidateRequest > implements IEmailValidateRequest {
    value?: string;
}

export interface IEmailValidateResponse {
    isValid: boolean;
    errorMessage?: string;
}
export class EmailValidateResponse extends BaseApiModelClass< IEmailValidateResponse > implements IEmailValidateResponse {
    isValid: boolean;
    errorMessage?: string;
}

export interface IEnzianDutyInfo {
    dutyXml?: string;
    dutyOriginalXml?: string;
}
export class EnzianDutyInfo extends BaseApiModelClass< IEnzianDutyInfo > implements IEnzianDutyInfo {
    dutyXml?: string;
    dutyOriginalXml?: string;
}

export enum ExcelImportItemStatus {
    Success = "Success",
    Warning = "Warning",
    Failed = "Failed",
}

export enum ExcelImportPhase {
    Import = "Import",
    Purge = "Purge",
    Summary = "Summary",
}

export interface IExcelImportProgressDto {
    phase: ExcelImportPhase;
    status: ExcelImportItemStatus;
    index: number;
    total: number;
    stationThreeLetterCode?: string;
    stationFourLetterCode?: string;
    rowNumber?: number;
    message?: string;
    error?: string;
    createdCount: number;
    updatedCount: number;
    clearedCount: number;
    deletedCount: number;
    summary: ExcelImportSummaryDto;
}
export class ExcelImportProgressDto extends BaseApiModelClass< IExcelImportProgressDto > implements IExcelImportProgressDto {
    phase: ExcelImportPhase;
    status: ExcelImportItemStatus;
    index: number;
    total: number;
    stationThreeLetterCode?: string;
    stationFourLetterCode?: string;
    rowNumber?: number;
    message?: string;
    error?: string;
    createdCount: number;
    updatedCount: number;
    clearedCount: number;
    deletedCount: number;
    summary: ExcelImportSummaryDto;
}

export interface IExcelImportSummaryDto {
    stationsTotal: number;
    stationsSucceeded: number;
    stationsFailed: number;
    createdCount: number;
    updatedCount: number;
    clearedCount: number;
    deletedCount: number;
    removeExtraData: boolean;
    dryRun: boolean;
    purgeStationsProcessed: number;
    purgeStationsFailed: number;
    queuedFlightRecomputes: number;
    queuedAirportPublications: number;
    warnings?: string[];
}
export class ExcelImportSummaryDto extends BaseApiModelClass< IExcelImportSummaryDto > implements IExcelImportSummaryDto {
    stationsTotal: number;
    stationsSucceeded: number;
    stationsFailed: number;
    createdCount: number;
    updatedCount: number;
    clearedCount: number;
    deletedCount: number;
    removeExtraData: boolean;
    dryRun: boolean;
    purgeStationsProcessed: number;
    purgeStationsFailed: number;
    queuedFlightRecomputes: number;
    queuedAirportPublications: number;
    warnings?: string[];
}

export interface IFile {
}
export class File extends BaseApiModelClass< IFile > implements IFile {
}

export interface IFileExplorerItemModel {
    name?: string;
    path?: string;
    isDirectory: boolean;
    size?: number;
    modifiedAt?: Date;
}
export class FileExplorerItemModel extends BaseApiModelClass< IFileExplorerItemModel > implements IFileExplorerItemModel {
    name?: string;
    path?: string;
    isDirectory: boolean;
    size?: number;
    modifiedAt?: Date;
}

export interface IFileExplorerListRequest {
    data?: string;
}
export class FileExplorerListRequest extends BaseApiModelClass< IFileExplorerListRequest > implements IFileExplorerListRequest {
    data?: string;
}

export interface IFileExplorerListResponse {
    path?: string;
    parentPath?: string;
    items?: FileExplorerItemModel[];
    error?: string;
}
export class FileExplorerListResponse extends BaseApiModelClass< IFileExplorerListResponse > implements IFileExplorerListResponse {
    path?: string;
    parentPath?: string;
    items?: FileExplorerItemModel[];
    error?: string;
}

export interface IFlightCargoUpdateRequest {
    cargoWeightKg?: number;
}
export class FlightCargoUpdateRequest extends BaseApiModelClass< IFlightCargoUpdateRequest > implements IFlightCargoUpdateRequest {
    cargoWeightKg?: number;
}

export interface IFlightCrewMemberDto {
    activityCodeName?: string;
    sortOrder: number;
    isCockpit: boolean;
    isCabin: boolean;
    personId: string;
    personCode?: string;
    firstName?: string;
    lastName?: string;
    hasNightStop: boolean;
}
export class FlightCrewMemberDto extends BaseApiModelClass< IFlightCrewMemberDto > implements IFlightCrewMemberDto {
    activityCodeName?: string;
    sortOrder: number;
    isCockpit: boolean;
    isCabin: boolean;
    personId: string;
    personCode?: string;
    firstName?: string;
    lastName?: string;
    hasNightStop: boolean;
}

export interface IFlightDelayDto {
    id: string;
    delayCode?: string;
    delaySubCode?: string;
    delayTime: number;
    delayDescription?: string;
}
export class FlightDelayDto extends BaseApiModelClass< IFlightDelayDto > implements IFlightDelayDto {
    id: string;
    delayCode?: string;
    delaySubCode?: string;
    delayTime: number;
    delayDescription?: string;
}

export interface IFlightDto {
    id: string;
    operationalSuffix?: string;
    netlineOpsLegId?: number;
    enzianId?: number;
    rotationId?: number;
    aircraftRotationId?: string;
    manuallyCreatedByPrincipalId?: string;
    existsNetlineOps: boolean;
    existsLegacy: boolean;
    existsEnzian: boolean;
    needsAttention: boolean;
    status: FlightStatus;
    statusIdentifier?: string;
    statusSupplementaryInfo?: string;
    statusChangeReason?: string;
    statusActionIdentifier?: string;
    isLongHaul: boolean;
    std?: number[];
    sta?: number[];
    etdUtc?: number;
    etaUtc?: number;
    oooi?: number[];
    aircraftId?: string;
    originalFlightId?: string;
    landingPilotFlyingId?: string;
    landingPilotMonitoringId?: string;
    isTypeRatingExam: boolean;
    crewEmployer?: string[];
    plannedAircraftTypeRcd?: string;
    totalDosimetry: number;
    pantryCode?: string;
    isPantryCodeOverridden: boolean;
    isPantryCodeRequired?: boolean;
    cargoWeightKg?: number;
}
export class FlightDto extends BaseApiModelClass< IFlightDto > implements IFlightDto {
    id: string;
    operationalSuffix?: string;
    netlineOpsLegId?: number;
    enzianId?: number;
    rotationId?: number;
    aircraftRotationId?: string;
    manuallyCreatedByPrincipalId?: string;
    existsNetlineOps: boolean;
    existsLegacy: boolean;
    existsEnzian: boolean;
    needsAttention: boolean;
    status: FlightStatus;
    statusIdentifier?: string;
    statusSupplementaryInfo?: string;
    statusChangeReason?: string;
    statusActionIdentifier?: string;
    isLongHaul: boolean;
    std?: number[];
    sta?: number[];
    etdUtc?: number;
    etaUtc?: number;
    oooi?: number[];
    aircraftId?: string;
    originalFlightId?: string;
    landingPilotFlyingId?: string;
    landingPilotMonitoringId?: string;
    isTypeRatingExam: boolean;
    crewEmployer?: string[];
    plannedAircraftTypeRcd?: string;
    totalDosimetry: number;
    pantryCode?: string;
    isPantryCodeOverridden: boolean;
    isPantryCodeRequired?: boolean;
    cargoWeightKg?: number;
}

export interface IFlightGridDto {
    id: string;
    operationalSuffix?: string;
    netlineOpsLegId?: number;
    enzianId?: number;
    rotationId?: number;
    aircraftRotationId?: string;
    manuallyCreatedByPrincipalId?: string;
    existsNetlineOps: boolean;
    existsLegacy: boolean;
    existsEnzian: boolean;
    needsAttention: boolean;
    status: FlightStatus;
    statusIdentifier?: string;
    statusSupplementaryInfo?: string;
    statusChangeReason?: string;
    statusActionIdentifier?: string;
    isLongHaul: boolean;
    std?: number[];
    sta?: number[];
    etdUtc?: number;
    etaUtc?: number;
    oooi?: number[];
    aircraftId?: string;
    originalFlightId?: string;
    landingPilotFlyingId?: string;
    landingPilotMonitoringId?: string;
    isTypeRatingExam: boolean;
    crewEmployer?: string[];
    plannedAircraftTypeRcd?: string;
    totalDosimetry: number;
    pantryCode?: string;
    isPantryCodeOverridden: boolean;
    isPantryCodeRequired?: boolean;
    cargoWeightKg?: number;
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    seats: FlightGridSeatsDto;
    reseatingsY?: number;
    zeroFuelWeightKg?: number;
}
export class FlightGridDto extends BaseApiModelClass< IFlightGridDto > implements IFlightGridDto {
    id: string;
    operationalSuffix?: string;
    netlineOpsLegId?: number;
    enzianId?: number;
    rotationId?: number;
    aircraftRotationId?: string;
    manuallyCreatedByPrincipalId?: string;
    existsNetlineOps: boolean;
    existsLegacy: boolean;
    existsEnzian: boolean;
    needsAttention: boolean;
    status: FlightStatus;
    statusIdentifier?: string;
    statusSupplementaryInfo?: string;
    statusChangeReason?: string;
    statusActionIdentifier?: string;
    isLongHaul: boolean;
    std?: number[];
    sta?: number[];
    etdUtc?: number;
    etaUtc?: number;
    oooi?: number[];
    aircraftId?: string;
    originalFlightId?: string;
    landingPilotFlyingId?: string;
    landingPilotMonitoringId?: string;
    isTypeRatingExam: boolean;
    crewEmployer?: string[];
    plannedAircraftTypeRcd?: string;
    totalDosimetry: number;
    pantryCode?: string;
    isPantryCodeOverridden: boolean;
    isPantryCodeRequired?: boolean;
    cargoWeightKg?: number;
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    seats: FlightGridSeatsDto;
    reseatingsY?: number;
    zeroFuelWeightKg?: number;
}

export interface IFlightGridDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class FlightGridDtoDataSourceLoadOptions extends BaseApiModelClass< IFlightGridDtoDataSourceLoadOptions > implements IFlightGridDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IFlightGridSeatsDto {
    physical?: number[];
    booked?: number[];
    standby?: number[];
}
export class FlightGridSeatsDto extends BaseApiModelClass< IFlightGridSeatsDto > implements IFlightGridSeatsDto {
    physical?: number[];
    booked?: number[];
    standby?: number[];
}

export interface IFlightPantryCodeOverrideUpdateRequest {
    carrierPantryCodeId?: string;
}
export class FlightPantryCodeOverrideUpdateRequest extends BaseApiModelClass< IFlightPantryCodeOverrideUpdateRequest > implements IFlightPantryCodeOverrideUpdateRequest {
    carrierPantryCodeId?: string;
}

export interface IFlightPnlEmailRequest {
    to: string;
    subject?: string;
    body: string;
}
export class FlightPnlEmailRequest extends BaseApiModelClass< IFlightPnlEmailRequest > implements IFlightPnlEmailRequest {
    to: string;
    subject?: string;
    body: string;
}

export interface IFlightSeatSummariesDto {
    summaries?: FlightSeatSummaryDto[];
    premiumEconomyCabinSeats?: number;
    economyReseatings?: number;
    updates?: SeatSummaryUpdateDto[];
}
export class FlightSeatSummariesDto extends BaseApiModelClass< IFlightSeatSummariesDto > implements IFlightSeatSummariesDto {
    summaries?: FlightSeatSummaryDto[];
    premiumEconomyCabinSeats?: number;
    economyReseatings?: number;
    updates?: SeatSummaryUpdateDto[];
}

export interface IFlightSeatSummaryDto {
    id: string;
    classRcd?: string;
    type: SeatSummaryType;
    count: number;
    isManualOverrule: boolean;
    source: SeatSummarySource;
    modifiedAtUtc: Date;
}
export class FlightSeatSummaryDto extends BaseApiModelClass< IFlightSeatSummaryDto > implements IFlightSeatSummaryDto {
    id: string;
    classRcd?: string;
    type: SeatSummaryType;
    count: number;
    isManualOverrule: boolean;
    source: SeatSummarySource;
    modifiedAtUtc: Date;
}

export interface IFlightSeatSummaryLogDto {
    changedAtUtc: Date;
    changedBy?: string;
    classRcd?: string;
    type: SeatSummaryType;
    oldCount?: number;
    newCount?: number;
}
export class FlightSeatSummaryLogDto extends BaseApiModelClass< IFlightSeatSummaryLogDto > implements IFlightSeatSummaryLogDto {
    changedAtUtc: Date;
    changedBy?: string;
    classRcd?: string;
    type: SeatSummaryType;
    oldCount?: number;
    newCount?: number;
}

export enum FlightStatus {
    Actual = "Actual",
    Cancelled = "Cancelled",
    Changed = "Changed",
    Deleted = "Deleted",
}

export interface IFlightUpdateModel {
    seatSummaries?: FlightSeatSummaryDto[];
}
export class FlightUpdateModel extends BaseApiModelClass< IFlightUpdateModel > implements IFlightUpdateModel {
    seatSummaries?: FlightSeatSummaryDto[];
}

export interface IFlightWeightDto {
    baseDom?: number;
    baseDoi?: number;
    pantryCode?: string;
    pantryCarrierCode?: string;
    pantryCodeOverrideId?: string;
    pantryCodeSource: PantryCodeSource;
    pantryCodeCalcId?: string;
    isPantryLocked: boolean;
    pantryStationRcd?: string;
    pantryStationFourLetterCode?: string;
    rotationFirstLegFlightId?: string;
    rotationFirstLegLabel?: string;
    aircraftRegistrationNumber?: string;
    cockpitCrewCount: number;
    cabinCrewCount: number;
    waterPercentage?: number;
    waterSource?: string;
    waterCorrectionDom: number;
    waterCorrectionDoi: number;
    noWaterUplift: boolean;
    hasNightstopCorrection: boolean;
    nightstopCrewCount: number;
    nightstopCorrectionDom?: number;
    nightstopCorrectionDoi?: number;
    cargoWeightKg?: number;
    paxCount: number;
    paxWeightKg: number;
    payloadKg?: number;
    finalDom?: number;
    finalDoi?: number;
    zeroFuelWeightKg?: number;
}
export class FlightWeightDto extends BaseApiModelClass< IFlightWeightDto > implements IFlightWeightDto {
    baseDom?: number;
    baseDoi?: number;
    pantryCode?: string;
    pantryCarrierCode?: string;
    pantryCodeOverrideId?: string;
    pantryCodeSource: PantryCodeSource;
    pantryCodeCalcId?: string;
    isPantryLocked: boolean;
    pantryStationRcd?: string;
    pantryStationFourLetterCode?: string;
    rotationFirstLegFlightId?: string;
    rotationFirstLegLabel?: string;
    aircraftRegistrationNumber?: string;
    cockpitCrewCount: number;
    cabinCrewCount: number;
    waterPercentage?: number;
    waterSource?: string;
    waterCorrectionDom: number;
    waterCorrectionDoi: number;
    noWaterUplift: boolean;
    hasNightstopCorrection: boolean;
    nightstopCrewCount: number;
    nightstopCorrectionDom?: number;
    nightstopCorrectionDoi?: number;
    cargoWeightKg?: number;
    paxCount: number;
    paxWeightKg: number;
    payloadKg?: number;
    finalDom?: number;
    finalDoi?: number;
    zeroFuelWeightKg?: number;
}

export interface IFlightWeightInputLogDto {
    changedAtUtc: Date;
    changedBy?: string;
    oldCargoWeightKg?: number;
    newCargoWeightKg?: number;
    oldPantryCode?: string;
    newPantryCode?: string;
}
export class FlightWeightInputLogDto extends BaseApiModelClass< IFlightWeightInputLogDto > implements IFlightWeightInputLogDto {
    changedAtUtc: Date;
    changedBy?: string;
    oldCargoWeightKg?: number;
    newCargoWeightKg?: number;
    oldPantryCode?: string;
    newPantryCode?: string;
}

export interface IFlightWeightSendStateDto {
    lastSentAtUtc?: Date;
    lastSentResult: QueueActionStatus;
    lastSentReason: WeightQueueReason;
    lastSentFinalDom?: number;
    lastSentFinalDoi?: number;
    lastSentZeroFuelWeightKg?: number;
    pendingRequestCount: number;
    pendingSinceUtc?: Date;
}
export class FlightWeightSendStateDto extends BaseApiModelClass< IFlightWeightSendStateDto > implements IFlightWeightSendStateDto {
    lastSentAtUtc?: Date;
    lastSentResult: QueueActionStatus;
    lastSentReason: WeightQueueReason;
    lastSentFinalDom?: number;
    lastSentFinalDoi?: number;
    lastSentZeroFuelWeightKg?: number;
    pendingRequestCount: number;
    pendingSinceUtc?: Date;
}

export interface IFlightWeightSnapshotDto {
    id: string;
    calculatedAtUtc: Date;
    result: QueueActionStatus;
    reason: WeightQueueReason;
    reasonDetails?: string;
    missingInput?: string;
    aircraftRegistrationNumber?: string;
    pantryCode?: string;
    pantryCarrierCode?: string;
    pantryCodeSource: PantryCodeSource;
    pantryStationRcd?: string;
    pantryStationFourLetterCode?: string;
    rotationFirstLegFlightId?: string;
    rotationFirstLegLabel?: string;
    cockpitCrewCount: number;
    cabinCrewCount: number;
    baseDom?: number;
    baseDoi?: number;
    waterPercentage?: number;
    noWaterUplift: boolean;
    waterCorrectionDom: number;
    waterCorrectionDoi: number;
    nightstopCrewCount: number;
    nightstopCorrectionDom?: number;
    nightstopCorrectionDoi?: number;
    cargoWeightKg?: number;
    paxCount: number;
    paxWeightKg: number;
    payloadKg?: number;
    finalDom?: number;
    finalDoi?: number;
    zeroFuelWeightKg?: number;
}
export class FlightWeightSnapshotDto extends BaseApiModelClass< IFlightWeightSnapshotDto > implements IFlightWeightSnapshotDto {
    id: string;
    calculatedAtUtc: Date;
    result: QueueActionStatus;
    reason: WeightQueueReason;
    reasonDetails?: string;
    missingInput?: string;
    aircraftRegistrationNumber?: string;
    pantryCode?: string;
    pantryCarrierCode?: string;
    pantryCodeSource: PantryCodeSource;
    pantryStationRcd?: string;
    pantryStationFourLetterCode?: string;
    rotationFirstLegFlightId?: string;
    rotationFirstLegLabel?: string;
    cockpitCrewCount: number;
    cabinCrewCount: number;
    baseDom?: number;
    baseDoi?: number;
    waterPercentage?: number;
    noWaterUplift: boolean;
    waterCorrectionDom: number;
    waterCorrectionDoi: number;
    nightstopCrewCount: number;
    nightstopCorrectionDom?: number;
    nightstopCorrectionDoi?: number;
    cargoWeightKg?: number;
    paxCount: number;
    paxWeightKg: number;
    payloadKg?: number;
    finalDom?: number;
    finalDoi?: number;
    zeroFuelWeightKg?: number;
}

export interface IFlightsListFilter {
    rowLimit?: number;
    periodFrom: Date;
    periodTo: Date;
    showInactive: boolean;
    needsAttention: boolean;
    groupByRotation: boolean;
    lookupLegacy: boolean;
    lookupEnzian: boolean;
}
export class FlightsListFilter extends BaseApiModelClass< IFlightsListFilter > implements IFlightsListFilter {
    rowLimit?: number;
    periodFrom: Date;
    periodTo: Date;
    showInactive: boolean;
    needsAttention: boolean;
    groupByRotation: boolean;
    lookupLegacy: boolean;
    lookupEnzian: boolean;
}

export interface IGroupingInfo {
    selector?: string;
    desc: boolean;
    groupInterval?: string;
    isExpanded?: boolean;
}
export class GroupingInfo extends BaseApiModelClass< IGroupingInfo > implements IGroupingInfo {
    selector?: string;
    desc: boolean;
    groupInterval?: string;
    isExpanded?: boolean;
}

export enum HotelDetailType {
    Company = "Company",
    Contact = "Contact",
    Phone = "Phone",
    Mobile = "Mobile",
    Fax = "Fax",
    Email = "Email",
    Remarks = "Remarks",
    PickUpTime = "PickUpTime",
}

export interface IInputQueueDeadlettersRequestModel {
    queueName?: string;
    fromSequenceNumber?: number;
}
export class InputQueueDeadlettersRequestModel extends BaseApiModelClass< IInputQueueDeadlettersRequestModel > implements IInputQueueDeadlettersRequestModel {
    queueName?: string;
    fromSequenceNumber?: number;
}

export interface IInputQueueStatisticsRequestModel {
    queueName?: string;
}
export class InputQueueStatisticsRequestModel extends BaseApiModelClass< IInputQueueStatisticsRequestModel > implements IInputQueueStatisticsRequestModel {
    queueName?: string;
}

export interface IJobDetailsModel {
    name?: string;
    instance?: string;
    isActive: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters: JobParameterDescriptionModel[];
}
export class JobDetailsModel extends BaseApiModelClass< IJobDetailsModel > implements IJobDetailsModel {
    name?: string;
    instance?: string;
    isActive: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters: JobParameterDescriptionModel[];
}

export interface IJobEnumModel {
    label?: string;
    value?: string;
}
export class JobEnumModel extends BaseApiModelClass< IJobEnumModel > implements IJobEnumModel {
    label?: string;
    value?: string;
}

export enum JobMisfireInstruction {
    Default = "Default",
    DoNothing = "DoNothing",
    FireAndProceed = "FireAndProceed",
    IgnoreMisfires = "IgnoreMisfires",
}

export interface IJobParameterDescriptionModel {
    name?: string;
    valueRaw?: string;
    jobValueRaw?: string;
    displayName?: string;
    description?: string;
    isOverrule?: boolean;
    type: JobParameterType;
    isRequired: boolean;
    enumValues?: JobEnumModel[];
    optionsUrl?: string;
}
export class JobParameterDescriptionModel extends BaseApiModelClass< IJobParameterDescriptionModel > implements IJobParameterDescriptionModel {
    name?: string;
    valueRaw?: string;
    jobValueRaw?: string;
    displayName?: string;
    description?: string;
    isOverrule?: boolean;
    type: JobParameterType;
    isRequired: boolean;
    enumValues?: JobEnumModel[];
    optionsUrl?: string;
}

export interface IJobParameterModel {
    name?: string;
    value?: string;
}
export class JobParameterModel extends BaseApiModelClass< IJobParameterModel > implements IJobParameterModel {
    name?: string;
    value?: string;
}

export interface IJobParameterOptionModel {
    value?: string;
    label?: string;
    hint?: string;
    status?: string;
}
export class JobParameterOptionModel extends BaseApiModelClass< IJobParameterOptionModel > implements IJobParameterOptionModel {
    value?: string;
    label?: string;
    hint?: string;
    status?: string;
}

export interface IJobParameterOptionsModel {
    options?: JobParameterOptionModel[];
    loadError?: string;
    isTruncated: boolean;
    searchMinLength: number;
}
export class JobParameterOptionsModel extends BaseApiModelClass< IJobParameterOptionsModel > implements IJobParameterOptionsModel {
    options?: JobParameterOptionModel[];
    loadError?: string;
    isTruncated: boolean;
    searchMinLength: number;
}

export enum JobParameterType {
    String = "String",
    Multiline = "Multiline",
    Integer = "Integer",
    Boolean = "Boolean",
    Enum = "Enum",
    Date = "Date",
    DateTime = "DateTime",
    CustomDropdown = "CustomDropdown",
}

export interface IJobSaveParametersModel {
    jobName?: string;
    triggerName?: string;
    isActive: boolean;
    instance?: string;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
    parameters?: JobParameterModel[];
}
export class JobSaveParametersModel extends BaseApiModelClass< IJobSaveParametersModel > implements IJobSaveParametersModel {
    jobName?: string;
    triggerName?: string;
    isActive: boolean;
    instance?: string;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
    parameters?: JobParameterModel[];
}

export interface IJobSaveParametersResult {
    errors?: string[];
    hasErrors: boolean;
}
export class JobSaveParametersResult extends BaseApiModelClass< IJobSaveParametersResult > implements IJobSaveParametersResult {
    errors?: string[];
    hasErrors: boolean;
}

export interface IJobStartModel {
    parameters?: JobParameterModel[];
}
export class JobStartModel extends BaseApiModelClass< IJobStartModel > implements IJobStartModel {
    parameters?: JobParameterModel[];
}

export enum JobStatus {
    Pending = "Pending",
    Success = "Success",
    Fail = "Fail",
}

export interface IJobTriggerShortInfo {
    name?: string;
    isActive: boolean;
    cronSchedule?: string;
    nextRunDateTime?: Date;
    nextAfterLastRunDateTime?: Date;
    lastRunDateTime?: Date;
    status: JobStatus;
    scheduleError?: string;
    dateTimeSchedule?: Date;
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
}
export class JobTriggerShortInfo extends BaseApiModelClass< IJobTriggerShortInfo > implements IJobTriggerShortInfo {
    name?: string;
    isActive: boolean;
    cronSchedule?: string;
    nextRunDateTime?: Date;
    nextAfterLastRunDateTime?: Date;
    lastRunDateTime?: Date;
    status: JobStatus;
    scheduleError?: string;
    dateTimeSchedule?: Date;
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
}

export interface IKafkaViewerFilter {
    triggerName: string;
    startFrom: KafkaViewerStartFrom;
    partition?: number;
    offset?: number;
    fromUtc?: Date;
    limit: number;
}
export class KafkaViewerFilter extends BaseApiModelClass< IKafkaViewerFilter > implements IKafkaViewerFilter {
    triggerName: string;
    startFrom: KafkaViewerStartFrom;
    partition?: number;
    offset?: number;
    fromUtc?: Date;
    limit: number;
}

export interface IKafkaViewerMessageDto {
    partition: number;
    offset: number;
    timestampUtc: Date;
    key?: string;
    value?: string;
    headers?: { [key: string]: string; };
}
export class KafkaViewerMessageDto extends BaseApiModelClass< IKafkaViewerMessageDto > implements IKafkaViewerMessageDto {
    partition: number;
    offset: number;
    timestampUtc: Date;
    key?: string;
    value?: string;
    headers?: { [key: string]: string; };
}

export interface IKafkaViewerPartitionDto {
    partition: number;
    lowWatermark: number;
    highWatermark: number;
    committedOffset?: number;
}
export class KafkaViewerPartitionDto extends BaseApiModelClass< IKafkaViewerPartitionDto > implements IKafkaViewerPartitionDto {
    partition: number;
    lowWatermark: number;
    highWatermark: number;
    committedOffset?: number;
}

export interface IKafkaViewerResult {
    topic?: string;
    partitions?: KafkaViewerPartitionDto[];
    messages?: KafkaViewerMessageDto[];
    errors?: string[];
    isTimedOut: boolean;
}
export class KafkaViewerResult extends BaseApiModelClass< IKafkaViewerResult > implements IKafkaViewerResult {
    topic?: string;
    partitions?: KafkaViewerPartitionDto[];
    messages?: KafkaViewerMessageDto[];
    errors?: string[];
    isTimedOut: boolean;
}

export enum KafkaViewerStartFrom {
    Latest = "Latest",
    Earliest = "Earliest",
    CommittedOffset = "CommittedOffset",
    Timestamp = "Timestamp",
    Offset = "Offset",
}

export interface IKafkaViewerTriggerDto {
    name?: string;
    isActive: boolean;
    server?: string;
    consumerTopic?: string;
    consumerGroup?: string;
}
export class KafkaViewerTriggerDto extends BaseApiModelClass< IKafkaViewerTriggerDto > implements IKafkaViewerTriggerDto {
    name?: string;
    isActive: boolean;
    server?: string;
    consumerTopic?: string;
    consumerGroup?: string;
}

export interface ILocationDto {
    latitude: number;
    longitude: number;
}
export class LocationDto extends BaseApiModelClass< ILocationDto > implements ILocationDto {
    latitude: number;
    longitude: number;
}

export interface ILogFileListItemModel {
    name?: string;
    fileName?: string;
    extension?: string;
    size: number;
    lastModified: Date;
}
export class LogFileListItemModel extends BaseApiModelClass< ILogFileListItemModel > implements ILogFileListItemModel {
    name?: string;
    fileName?: string;
    extension?: string;
    size: number;
    lastModified: Date;
}

export enum MailQueueStatus {
    NotSent = "NotSent",
    Sent = "Sent",
    Failed = "Failed",
    Cancelled = "Cancelled",
}

export enum MailQueueType {
    SapExportFail = "SapExportFail",
    FlightPnl = "FlightPnl",
}

export interface IManualFlightConfigurationHintDto {
    aircraftConfigurationRcd?: string;
    takenFromFlightLabel?: string;
}
export class ManualFlightConfigurationHintDto extends BaseApiModelClass< IManualFlightConfigurationHintDto > implements IManualFlightConfigurationHintDto {
    aircraftConfigurationRcd?: string;
    takenFromFlightLabel?: string;
}

export interface IManualFlightCreateRequest {
    operationalSuffix?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    aircraftTypeRcd: string;
    aircraftId?: string;
    aircraftConfigurationRcd?: string;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    serviceType?: string;
    airlineRcd: string;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
}
export class ManualFlightCreateRequest extends BaseApiModelClass< IManualFlightCreateRequest > implements IManualFlightCreateRequest {
    operationalSuffix?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    aircraftTypeRcd: string;
    aircraftId?: string;
    aircraftConfigurationRcd?: string;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    serviceType?: string;
    airlineRcd: string;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
}

export interface IManualFlightDto {
    operationalSuffix?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    aircraftTypeRcd: string;
    aircraftId?: string;
    aircraftConfigurationRcd?: string;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    serviceType?: string;
    airlineRcd: string;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    id: string;
    legSequenceNumber: number;
    manuallyCreatedByDisplayName?: string;
    manuallyCreatedAtUtc?: Date;
    modifiedByDisplayName?: string;
    modifiedAtUtc: Date;
}
export class ManualFlightDto extends BaseApiModelClass< IManualFlightDto > implements IManualFlightDto {
    operationalSuffix?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    aircraftTypeRcd: string;
    aircraftId?: string;
    aircraftConfigurationRcd?: string;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    serviceType?: string;
    airlineRcd: string;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    id: string;
    legSequenceNumber: number;
    manuallyCreatedByDisplayName?: string;
    manuallyCreatedAtUtc?: Date;
    modifiedByDisplayName?: string;
    modifiedAtUtc: Date;
}

export interface IManualFlightHintDto {
    flightNumber: number;
    legSequenceNumber: number;
    originRcd?: string;
    destinationRcd?: string;
    aircraftTypeRcd?: string;
    flightCount: number;
    nearestFlightDepartureDateTimeUtc: Date;
    nearestFlightArrivalDateTimeUtc: Date;
}
export class ManualFlightHintDto extends BaseApiModelClass< IManualFlightHintDto > implements IManualFlightHintDto {
    flightNumber: number;
    legSequenceNumber: number;
    originRcd?: string;
    destinationRcd?: string;
    aircraftTypeRcd?: string;
    flightCount: number;
    nearestFlightDepartureDateTimeUtc: Date;
    nearestFlightArrivalDateTimeUtc: Date;
}

export interface IManualFlightLegDto {
    legSequenceNumber: number;
    originRcd?: string;
    destinationRcd?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
}
export class ManualFlightLegDto extends BaseApiModelClass< IManualFlightLegDto > implements IManualFlightLegDto {
    legSequenceNumber: number;
    originRcd?: string;
    destinationRcd?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
}

export interface IManualFlightLookupsDto {
    carriers?: CarrierDto[];
    aircraftTypeRcds?: string[];
}
export class ManualFlightLookupsDto extends BaseApiModelClass< IManualFlightLookupsDto > implements IManualFlightLookupsDto {
    carriers?: CarrierDto[];
    aircraftTypeRcds?: string[];
}

export interface IManualFlightNextLegDto {
    legSequenceNumber: number;
    isPlannedBySourceSystem: boolean;
    previousLeg: ManualFlightLegDto;
}
export class ManualFlightNextLegDto extends BaseApiModelClass< IManualFlightNextLegDto > implements IManualFlightNextLegDto {
    legSequenceNumber: number;
    isPlannedBySourceSystem: boolean;
    previousLeg: ManualFlightLegDto;
}

export interface IManualFlightUpdateRequest {
    operationalSuffix?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    aircraftTypeRcd: string;
    aircraftId?: string;
    aircraftConfigurationRcd?: string;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    serviceType?: string;
}
export class ManualFlightUpdateRequest extends BaseApiModelClass< IManualFlightUpdateRequest > implements IManualFlightUpdateRequest {
    operationalSuffix?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    aircraftTypeRcd: string;
    aircraftId?: string;
    aircraftConfigurationRcd?: string;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    serviceType?: string;
}

export interface IMessageHistoryModel {
    id: string;
    timestamp: Date;
    label?: string;
    message?: string;
    isOutDirection: boolean;
}
export class MessageHistoryModel extends BaseApiModelClass< IMessageHistoryModel > implements IMessageHistoryModel {
    id: string;
    timestamp: Date;
    label?: string;
    message?: string;
    isOutDirection: boolean;
}

export enum MessageLabel {
    Error = "Error",
    AircraftMaintenance = "AircraftMaintenance",
    Aircraft = "Aircraft",
    AircraftType = "AircraftType",
    Airport = "Airport",
    Flight = "Flight",
    AcarsOooi = "AcarsOooi",
    AcarsM45 = "AcarsM45",
    Person = "Person",
    Rotation = "Rotation",
    PersonDay = "PersonDay",
    CrewNotification = "CrewNotification",
    CrewAssignment = "CrewAssignment",
    FlightMeal = "FlightMeal",
    JeppesenError = "JeppesenError",
    JeppesenFlight = "JeppesenFlight",
    JeppesenTrip = "JeppesenTrip",
    JeppesenDuty = "JeppesenDuty",
    JeppesenCheckerTrainee = "JeppesenCheckerTrainee",
    LegDetail = "LegDetail",
    AircraftsAssignment = "AircraftsAssignment",
    FlightMealService = "FlightMealService",
    SsimFlightAdded = "SsimFlightAdded",
    SsimFlightModified = "SsimFlightModified",
    SsimFlightDeleted = "SsimFlightDeleted",
    FlightPilotStatus = "FlightPilotStatus",
    FlightProtocol = "FlightProtocol",
    FlightWeight = "FlightWeight",
    AlteaDcsCatering = "AlteaDcsCatering",
    CateredMeals = "CateredMeals",
    KafkaReceived = "KafkaReceived",
    PersonAbsence = "PersonAbsence",
    IrregCase = "IrregCase",
    SabreCrewMessage = "SabreCrewMessage",
    Unknown = "Unknown",
}

export interface IMessageStatisticsItemModel {
    key?: string;
    value: number;
}
export class MessageStatisticsItemModel extends BaseApiModelClass< IMessageStatisticsItemModel > implements IMessageStatisticsItemModel {
    key?: string;
    value: number;
}

export interface IMessageStatisticsModel {
    messageType?: string;
    statistics?: MessageStatisticsItemModel[];
}
export class MessageStatisticsModel extends BaseApiModelClass< IMessageStatisticsModel > implements IMessageStatisticsModel {
    messageType?: string;
    statistics?: MessageStatisticsItemModel[];
}

export enum MessageTypeHealthStatus {
    Ok = "Ok",
    Overdue = "Overdue",
    DeadLettered = "DeadLettered",
    NotTracked = "NotTracked",
}

export enum PantryCodeSource {
    None = "None",
    Station = "Station",
    LegOverride = "LegOverride",
    RotationOverride = "RotationOverride",
    Stored = "Stored",
}

export interface IPantryCompletenessDto {
    stationsAffectedCount: number;
    gaps?: PantryGapDto[];
}
export class PantryCompletenessDto extends BaseApiModelClass< IPantryCompletenessDto > implements IPantryCompletenessDto {
    stationsAffectedCount: number;
    gaps?: PantryGapDto[];
}

export interface IPantryGapDto {
    stationFourLetterCode?: string;
    carrierCode?: string;
    aircraftFamilyId: string;
    aircraftFamilyName?: string;
    closestFlightLabel?: string;
}
export class PantryGapDto extends BaseApiModelClass< IPantryGapDto > implements IPantryGapDto {
    stationFourLetterCode?: string;
    carrierCode?: string;
    aircraftFamilyId: string;
    aircraftFamilyName?: string;
    closestFlightLabel?: string;
}

export interface IPeopleAssistEntryDetailDto {
    id: string;
    kind: PeopleAssistEntryKind;
    identifier?: string;
    secondaryIdentifier?: string;
    requestNumber?: number;
    personCode?: string;
    originalContent?: string;
    actualContent?: string;
    createdAtUtc: Date;
    modifiedAtUtc: Date;
    logs?: PeopleAssistLogDto[];
}
export class PeopleAssistEntryDetailDto extends BaseApiModelClass< IPeopleAssistEntryDetailDto > implements IPeopleAssistEntryDetailDto {
    id: string;
    kind: PeopleAssistEntryKind;
    identifier?: string;
    secondaryIdentifier?: string;
    requestNumber?: number;
    personCode?: string;
    originalContent?: string;
    actualContent?: string;
    createdAtUtc: Date;
    modifiedAtUtc: Date;
    logs?: PeopleAssistLogDto[];
}

export interface IPeopleAssistEntryGridData {
    data?: PeopleAssistEntryListItemDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class PeopleAssistEntryGridData extends BaseApiModelClass< IPeopleAssistEntryGridData > implements IPeopleAssistEntryGridData {
    data?: PeopleAssistEntryListItemDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export enum PeopleAssistEntryKind {
    Form = "Form",
    Task = "Task",
}

export interface IPeopleAssistEntryListItemDto {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    kind: PeopleAssistEntryKind;
    identifier?: string;
    secondaryIdentifier?: string;
    requestNumber?: number;
    personCode?: string;
    createdAtUtc: Date;
    modifiedAtUtc: Date;
    modifiedDateUtc: Date;
    logCount: number;
}
export class PeopleAssistEntryListItemDto extends BaseApiModelClass< IPeopleAssistEntryListItemDto > implements IPeopleAssistEntryListItemDto {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    id: string;
    kind: PeopleAssistEntryKind;
    identifier?: string;
    secondaryIdentifier?: string;
    requestNumber?: number;
    personCode?: string;
    createdAtUtc: Date;
    modifiedAtUtc: Date;
    modifiedDateUtc: Date;
    logCount: number;
}

export interface IPeopleAssistEntryListItemDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class PeopleAssistEntryListItemDtoDataSourceLoadOptions extends BaseApiModelClass< IPeopleAssistEntryListItemDtoDataSourceLoadOptions > implements IPeopleAssistEntryListItemDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export interface IPeopleAssistFilter {
    rowLimit?: number;
    search?: string;
    kind: PeopleAssistEntryKind;
}
export class PeopleAssistFilter extends BaseApiModelClass< IPeopleAssistFilter > implements IPeopleAssistFilter {
    rowLimit?: number;
    search?: string;
    kind: PeopleAssistEntryKind;
}

export interface IPeopleAssistIllnessBlockDto {
    id: string;
    dateFrom: Date;
    dateTo: Date;
    blockDays: number;
    activityDays: number;
    activityCodeName?: string;
    status: AbsenceBlockStatus;
    isProcessed: boolean;
    isLongTerm: boolean;
    processedLength?: number;
    peopleDocId?: string;
    requestNumber?: number;
    lastErrorMessage?: string;
    lastDecision: PersonAbsenceLogType;
    createdAtUtc: Date;
    modifiedAtUtc: Date;
}
export class PeopleAssistIllnessBlockDto extends BaseApiModelClass< IPeopleAssistIllnessBlockDto > implements IPeopleAssistIllnessBlockDto {
    id: string;
    dateFrom: Date;
    dateTo: Date;
    blockDays: number;
    activityDays: number;
    activityCodeName?: string;
    status: AbsenceBlockStatus;
    isProcessed: boolean;
    isLongTerm: boolean;
    processedLength?: number;
    peopleDocId?: string;
    requestNumber?: number;
    lastErrorMessage?: string;
    lastDecision: PersonAbsenceLogType;
    createdAtUtc: Date;
    modifiedAtUtc: Date;
}

export interface IPeopleAssistIllnessFilter {
    rowLimit?: number;
    search?: string;
    onlyActiveLongTerm: boolean;
}
export class PeopleAssistIllnessFilter extends BaseApiModelClass< IPeopleAssistIllnessFilter > implements IPeopleAssistIllnessFilter {
    rowLimit?: number;
    search?: string;
    onlyActiveLongTerm: boolean;
}

export interface IPeopleAssistIllnessFormDto {
    id: string;
    requestNumber: number;
    formId?: string;
    formName?: string;
    createdAtUtc: Date;
    modifiedAtUtc: Date;
}
export class PeopleAssistIllnessFormDto extends BaseApiModelClass< IPeopleAssistIllnessFormDto > implements IPeopleAssistIllnessFormDto {
    id: string;
    requestNumber: number;
    formId?: string;
    formName?: string;
    createdAtUtc: Date;
    modifiedAtUtc: Date;
}

export interface IPeopleAssistIllnessLiveFormDto {
    id: string;
    requestNumber: number;
    formId?: string;
    status?: string;
    customStatus?: string;
    keepAbsence?: string;
    linkedToRequestNumber?: number;
    isReceivedByDcc: boolean;
    error?: string;
}
export class PeopleAssistIllnessLiveFormDto extends BaseApiModelClass< IPeopleAssistIllnessLiveFormDto > implements IPeopleAssistIllnessLiveFormDto {
    id: string;
    requestNumber: number;
    formId?: string;
    status?: string;
    customStatus?: string;
    keepAbsence?: string;
    linkedToRequestNumber?: number;
    isReceivedByDcc: boolean;
    error?: string;
}

export interface IPeopleAssistIllnessLongTermDto {
    id: string;
    status: PeopleAssistIllnessLongTermStatus;
    blockId?: string;
    dateFrom: Date;
    dateTo?: Date;
    createdAt: Date;
    confirmedAt?: Date;
    confirmedByRequestNumber?: number;
    lastRenewRequestAt?: Date;
    lastRenewRequestNumber?: number;
    nextRenewDueUtc?: Date;
    closedAt?: Date;
    closedByRequestNumber?: number;
}
export class PeopleAssistIllnessLongTermDto extends BaseApiModelClass< IPeopleAssistIllnessLongTermDto > implements IPeopleAssistIllnessLongTermDto {
    id: string;
    status: PeopleAssistIllnessLongTermStatus;
    blockId?: string;
    dateFrom: Date;
    dateTo?: Date;
    createdAt: Date;
    confirmedAt?: Date;
    confirmedByRequestNumber?: number;
    lastRenewRequestAt?: Date;
    lastRenewRequestNumber?: number;
    nextRenewDueUtc?: Date;
    closedAt?: Date;
    closedByRequestNumber?: number;
}

export enum PeopleAssistIllnessLongTermStatus {
    None = "None",
    Candidate = "Candidate",
    Confirmed = "Confirmed",
    Closed = "Closed",
}

export interface IPeopleAssistIllnessPersonDetailDto {
    personId: string;
    personCode?: string;
    personName?: string;
    blocks?: PeopleAssistIllnessBlockDto[];
    longTermIlls?: PeopleAssistIllnessLongTermDto[];
    forms?: PeopleAssistIllnessFormDto[];
    timeline?: PeopleAssistIllnessTimelineItemDto[];
}
export class PeopleAssistIllnessPersonDetailDto extends BaseApiModelClass< IPeopleAssistIllnessPersonDetailDto > implements IPeopleAssistIllnessPersonDetailDto {
    personId: string;
    personCode?: string;
    personName?: string;
    blocks?: PeopleAssistIllnessBlockDto[];
    longTermIlls?: PeopleAssistIllnessLongTermDto[];
    forms?: PeopleAssistIllnessFormDto[];
    timeline?: PeopleAssistIllnessTimelineItemDto[];
}

export interface IPeopleAssistIllnessPersonGridData {
    data?: PeopleAssistIllnessPersonListItemDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class PeopleAssistIllnessPersonGridData extends BaseApiModelClass< IPeopleAssistIllnessPersonGridData > implements IPeopleAssistIllnessPersonGridData {
    data?: PeopleAssistIllnessPersonListItemDto[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IPeopleAssistIllnessPersonListItemDto {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode?: string;
    personName?: string;
    blockCount: number;
    lastBlockDateFrom?: Date;
    lastChangeAtUtc?: Date;
    longTermStatus: PeopleAssistIllnessLongTermStatus;
    longTermDateFrom?: Date;
    longTermDateTo?: Date;
    nextRenewDueUtc?: Date;
}
export class PeopleAssistIllnessPersonListItemDto extends BaseApiModelClass< IPeopleAssistIllnessPersonListItemDto > implements IPeopleAssistIllnessPersonListItemDto {
    key?: any;
    items?: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode?: string;
    personName?: string;
    blockCount: number;
    lastBlockDateFrom?: Date;
    lastChangeAtUtc?: Date;
    longTermStatus: PeopleAssistIllnessLongTermStatus;
    longTermDateFrom?: Date;
    longTermDateTo?: Date;
    nextRenewDueUtc?: Date;
}

export interface IPeopleAssistIllnessPersonListItemDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}
export class PeopleAssistIllnessPersonListItemDtoDataSourceLoadOptions extends BaseApiModelClass< IPeopleAssistIllnessPersonListItemDtoDataSourceLoadOptions > implements IPeopleAssistIllnessPersonListItemDtoDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    filter?: any[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
}

export enum PeopleAssistIllnessStage {
    CrewPage = "CrewPage",
    DataSync = "DataSync",
    PeopleAssist = "PeopleAssist",
}

export interface IPeopleAssistIllnessTimelineItemDto {
    timestamp: Date;
    stage: PeopleAssistIllnessStage;
    eventType?: string;
    title?: string;
    details?: string;
    blockId?: string;
    longTermIllId?: string;
    formId?: string;
    requestNumber?: number;
    isError: boolean;
    isRestored: boolean;
}
export class PeopleAssistIllnessTimelineItemDto extends BaseApiModelClass< IPeopleAssistIllnessTimelineItemDto > implements IPeopleAssistIllnessTimelineItemDto {
    timestamp: Date;
    stage: PeopleAssistIllnessStage;
    eventType?: string;
    title?: string;
    details?: string;
    blockId?: string;
    longTermIllId?: string;
    formId?: string;
    requestNumber?: number;
    isError: boolean;
    isRestored: boolean;
}

export interface IPeopleAssistLiveFilter {
    statuses?: string[];
    cursor?: string;
}
export class PeopleAssistLiveFilter extends BaseApiModelClass< IPeopleAssistLiveFilter > implements IPeopleAssistLiveFilter {
    statuses?: string[];
    cursor?: string;
}

export interface IPeopleAssistLiveFormDetailDto {
    raw?: string;
}
export class PeopleAssistLiveFormDetailDto extends BaseApiModelClass< IPeopleAssistLiveFormDetailDto > implements IPeopleAssistLiveFormDetailDto {
    raw?: string;
}

export interface IPeopleAssistLiveFormListItemDto {
    id: string;
    requestNumber: number;
    status?: string;
    formId?: string;
    createdAt?: Date;
}
export class PeopleAssistLiveFormListItemDto extends BaseApiModelClass< IPeopleAssistLiveFormListItemDto > implements IPeopleAssistLiveFormListItemDto {
    id: string;
    requestNumber: number;
    status?: string;
    formId?: string;
    createdAt?: Date;
}

export interface IPeopleAssistLiveFormsResult {
    items?: PeopleAssistLiveFormListItemDto[];
    nextCursor?: string;
}
export class PeopleAssistLiveFormsResult extends BaseApiModelClass< IPeopleAssistLiveFormsResult > implements IPeopleAssistLiveFormsResult {
    items?: PeopleAssistLiveFormListItemDto[];
    nextCursor?: string;
}

export interface IPeopleAssistLogDto {
    id: string;
    timestamp: Date;
    operation?: string;
    methodUrl?: string;
    body?: string;
    actualContent?: string;
    errorMessage?: string;
}
export class PeopleAssistLogDto extends BaseApiModelClass< IPeopleAssistLogDto > implements IPeopleAssistLogDto {
    id: string;
    timestamp: Date;
    operation?: string;
    methodUrl?: string;
    body?: string;
    actualContent?: string;
    errorMessage?: string;
}

export interface IPermissionModel {
    id: number;
    codeName?: string;
    description?: string;
    parentPermissionId?: number;
    tenantType: TenantType;
}
export class PermissionModel extends BaseApiModelClass< IPermissionModel > implements IPermissionModel {
    id: number;
    codeName?: string;
    description?: string;
    parentPermissionId?: number;
    tenantType: TenantType;
}

export enum PersonAbsenceLogType {
    MessageReceived = "MessageReceived",
    IgnoredOld = "IgnoredOld",
    Deleted = "Deleted",
    NoContract = "NoContract",
    NoFunction = "NoFunction",
    FormCreated = "FormCreated",
    FormUpdated = "FormUpdated",
    BelowThreshold = "BelowThreshold",
    AlreadyProcessed = "AlreadyProcessed",
    SuppressedByLongTerm = "SuppressedByLongTerm",
    NoFormRequired = "NoFormRequired",
    Error = "Error",
    LongTermExtended = "LongTermExtended",
    LongTermCreated = "LongTermCreated",
    LongTermConfirmed = "LongTermConfirmed",
    LongTermRenewed = "LongTermRenewed",
    LongTermClosed = "LongTermClosed",
    LongTermAnswerIgnored = "LongTermAnswerIgnored",
    LongTermRenewRequested = "LongTermRenewRequested",
    LongTermRequestReceived = "LongTermRequestReceived",
    LongTermRequestFailed = "LongTermRequestFailed",
}

export interface IPredefinedRoleModel {
    id: number;
    codeName?: string;
    description?: string;
    permissionIds?: number[];
}
export class PredefinedRoleModel extends BaseApiModelClass< IPredefinedRoleModel > implements IPredefinedRoleModel {
    id: number;
    codeName?: string;
    description?: string;
    permissionIds?: number[];
}

export enum QueueActionStatus {
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Skipped = "Skipped",
}

export interface IQueueModel {
    id: number;
    name?: string;
}
export class QueueModel extends BaseApiModelClass< IQueueModel > implements IQueueModel {
    id: number;
    name?: string;
}

export interface IQueueStatisticsModel {
    queueName?: string;
    status?: string;
    errorMessage?: string;
    messagesCount?: number;
    deadletterMessagesCount?: number;
    messagesPerMinuteIn: number;
    messagesPerMinuteOut: number;
}
export class QueueStatisticsModel extends BaseApiModelClass< IQueueStatisticsModel > implements IQueueStatisticsModel {
    queueName?: string;
    status?: string;
    errorMessage?: string;
    messagesCount?: number;
    deadletterMessagesCount?: number;
    messagesPerMinuteIn: number;
    messagesPerMinuteOut: number;
}

export enum SchedulerStatus {
    ServiceNotStarted = "ServiceNotStarted",
    WaitingForDatabase = "WaitingForDatabase",
    SchedulingJobs = "SchedulingJobs",
    FailedToStart = "FailedToStart",
    SchedulingPostponedJobs = "SchedulingPostponedJobs",
    Starting = "Starting",
    Started = "Started",
    ShuttingDown = "ShuttingDown",
    StutDown = "StutDown",
}

export enum SeatSummarySource {
    Unknown = "Unknown",
    Avantik = "Avantik",
    MealServiceTelex = "MealServiceTelex",
    Manual = "Manual",
}

export enum SeatSummaryType {
    Physical = "Physical",
    Booked = "Booked",
    Flown = "Flown",
    Allotment = "Allotment",
    Standby = "Standby",
    AllotmentBooked = "AllotmentBooked",
}

export interface ISeatSummaryUpdateDto {
    types?: SeatSummaryType[];
    process?: string;
    job?: string;
    trigger?: string;
    nextRunUtc?: Date;
    schedule?: string;
}
export class SeatSummaryUpdateDto extends BaseApiModelClass< ISeatSummaryUpdateDto > implements ISeatSummaryUpdateDto {
    types?: SeatSummaryType[];
    process?: string;
    job?: string;
    trigger?: string;
    nextRunUtc?: Date;
    schedule?: string;
}

export interface ISelfTestResult {
    name?: string;
    status: SelfTestResultStatus;
    title?: string;
    message?: string;
    payload?: any;
}
export class SelfTestResult extends BaseApiModelClass< ISelfTestResult > implements ISelfTestResult {
    name?: string;
    status: SelfTestResultStatus;
    title?: string;
    message?: string;
    payload?: any;
}

export enum SelfTestResultStatus {
    Success = "Success",
    Warning = "Warning",
    Fail = "Fail",
}

export interface IServiceBusMessageTypeHealthModel {
    id: string;
    type?: string;
    name?: string;
    expectedFrequency?: string;
    messagesLastDay: number;
    lastMessageDateTimeUtc?: Date;
    avgProcessingTimeMs?: number;
    deadLetterCount: number;
    status: MessageTypeHealthStatus;
}
export class ServiceBusMessageTypeHealthModel extends BaseApiModelClass< IServiceBusMessageTypeHealthModel > implements IServiceBusMessageTypeHealthModel {
    id: string;
    type?: string;
    name?: string;
    expectedFrequency?: string;
    messagesLastDay: number;
    lastMessageDateTimeUtc?: Date;
    avgProcessingTimeMs?: number;
    deadLetterCount: number;
    status: MessageTypeHealthStatus;
}

export interface ISortingInfo {
    selector?: string;
    desc: boolean;
}
export class SortingInfo extends BaseApiModelClass< ISortingInfo > implements ISortingInfo {
    selector?: string;
    desc: boolean;
}

export interface IStationManagerDto {
    firstname?: string;
    lastname?: string;
    phone?: string;
    email?: string;
}
export class StationManagerDto extends BaseApiModelClass< IStationManagerDto > implements IStationManagerDto {
    firstname?: string;
    lastname?: string;
    phone?: string;
    email?: string;
}

export interface IStationPantryCodeDto {
    carrierCode?: string;
    airportFourLetterCode?: string;
    aircraftFamilyId: string;
    carrierPantryCodeId?: string;
    isRequired: boolean;
}
export class StationPantryCodeDto extends BaseApiModelClass< IStationPantryCodeDto > implements IStationPantryCodeDto {
    carrierCode?: string;
    airportFourLetterCode?: string;
    aircraftFamilyId: string;
    carrierPantryCodeId?: string;
    isRequired: boolean;
}

export interface IStationPantryCodeLogDto {
    id: string;
    carrierCode?: string;
    airportFourLetterCode?: string;
    aircraftFamilyName?: string;
    oldPantryCode?: string;
    newPantryCode?: string;
    changedAtUtc: Date;
    changedBy?: string;
}
export class StationPantryCodeLogDto extends BaseApiModelClass< IStationPantryCodeLogDto > implements IStationPantryCodeLogDto {
    id: string;
    carrierCode?: string;
    airportFourLetterCode?: string;
    aircraftFamilyName?: string;
    oldPantryCode?: string;
    newPantryCode?: string;
    changedAtUtc: Date;
    changedBy?: string;
}

export interface IStationPantryCodeUpdateRequest {
    carrierCode?: string;
    airportFourLetterCode?: string;
    aircraftFamilyId: string;
    carrierPantryCodeId?: string;
}
export class StationPantryCodeUpdateRequest extends BaseApiModelClass< IStationPantryCodeUpdateRequest > implements IStationPantryCodeUpdateRequest {
    carrierCode?: string;
    airportFourLetterCode?: string;
    aircraftFamilyId: string;
    carrierPantryCodeId?: string;
}

export interface IStationWaterQuantityLegDto {
    originFourLetterCode?: string;
    originThreeLetterCode?: string;
    destinationFourLetterCode?: string;
    destinationThreeLetterCode?: string;
    aircraftTypeGroupId: string;
    quantityPercentage?: number;
    isMandatory: boolean;
}
export class StationWaterQuantityLegDto extends BaseApiModelClass< IStationWaterQuantityLegDto > implements IStationWaterQuantityLegDto {
    originFourLetterCode?: string;
    originThreeLetterCode?: string;
    destinationFourLetterCode?: string;
    destinationThreeLetterCode?: string;
    aircraftTypeGroupId: string;
    quantityPercentage?: number;
    isMandatory: boolean;
}

export interface IStationWaterQuantityLegLogDto {
    originFourLetterCode?: string;
    originThreeLetterCode?: string;
    destinationFourLetterCode?: string;
    destinationThreeLetterCode?: string;
    aircraftTypeGroupId: string;
    groupName?: string;
    quantityPercentage?: number;
    action: AuditAction;
    timestamp: Date;
    changedBy?: string;
}
export class StationWaterQuantityLegLogDto extends BaseApiModelClass< IStationWaterQuantityLegLogDto > implements IStationWaterQuantityLegLogDto {
    originFourLetterCode?: string;
    originThreeLetterCode?: string;
    destinationFourLetterCode?: string;
    destinationThreeLetterCode?: string;
    aircraftTypeGroupId: string;
    groupName?: string;
    quantityPercentage?: number;
    action: AuditAction;
    timestamp: Date;
    changedBy?: string;
}

export interface IStationWaterQuantityLegUpdateRequest {
    originFourLetterCode?: string;
    destinationFourLetterCode?: string;
    aircraftTypeGroupId: string;
    quantityPercentage?: number;
}
export class StationWaterQuantityLegUpdateRequest extends BaseApiModelClass< IStationWaterQuantityLegUpdateRequest > implements IStationWaterQuantityLegUpdateRequest {
    originFourLetterCode?: string;
    destinationFourLetterCode?: string;
    aircraftTypeGroupId: string;
    quantityPercentage?: number;
}

export interface ISummaryInfo {
    selector?: string;
    summaryType?: string;
}
export class SummaryInfo extends BaseApiModelClass< ISummaryInfo > implements ISummaryInfo {
    selector?: string;
    summaryType?: string;
}

export enum TenantType {
    DCC = "DCC",
    DataBridge = "DataBridge",
}

export interface IWaterQuantityCompletenessDto {
    stationsAffectedCount: number;
    gaps?: WaterQuantityGapDto[];
}
export class WaterQuantityCompletenessDto extends BaseApiModelClass< IWaterQuantityCompletenessDto > implements IWaterQuantityCompletenessDto {
    stationsAffectedCount: number;
    gaps?: WaterQuantityGapDto[];
}

export interface IWaterQuantityGapDto {
    stationFourLetterCode?: string;
    originFourLetterCode?: string;
    originThreeLetterCode?: string;
    destinationFourLetterCode?: string;
    destinationThreeLetterCode?: string;
    aircraftTypeGroupId: string;
    aircraftTypeGroupName?: string;
    closestFlightLabel?: string;
}
export class WaterQuantityGapDto extends BaseApiModelClass< IWaterQuantityGapDto > implements IWaterQuantityGapDto {
    stationFourLetterCode?: string;
    originFourLetterCode?: string;
    originThreeLetterCode?: string;
    destinationFourLetterCode?: string;
    destinationThreeLetterCode?: string;
    aircraftTypeGroupId: string;
    aircraftTypeGroupName?: string;
    closestFlightLabel?: string;
}

export interface IWaterQuantityWeightCorrectionDto {
    waterLevel: number;
    domCorrection: number;
    doiCorrection: number;
}
export class WaterQuantityWeightCorrectionDto extends BaseApiModelClass< IWaterQuantityWeightCorrectionDto > implements IWaterQuantityWeightCorrectionDto {
    waterLevel: number;
    domCorrection: number;
    doiCorrection: number;
}

export interface IWaterQuantityWeightCorrectionLogDto {
    id: string;
    aircraftTypeGroupId: string;
    waterLevel: number;
    domCorrection: number;
    doiCorrection: number;
    action: AuditAction;
    timestamp: Date;
    changedBy?: string;
}
export class WaterQuantityWeightCorrectionLogDto extends BaseApiModelClass< IWaterQuantityWeightCorrectionLogDto > implements IWaterQuantityWeightCorrectionLogDto {
    id: string;
    aircraftTypeGroupId: string;
    waterLevel: number;
    domCorrection: number;
    doiCorrection: number;
    action: AuditAction;
    timestamp: Date;
    changedBy?: string;
}

export interface IWaterQuantityWeightCorrectionUpdateRequest {
    aircraftId: string;
    waterLevel: number;
    domCorrection: number;
    doiCorrection: number;
}
export class WaterQuantityWeightCorrectionUpdateRequest extends BaseApiModelClass< IWaterQuantityWeightCorrectionUpdateRequest > implements IWaterQuantityWeightCorrectionUpdateRequest {
    aircraftId: string;
    waterLevel: number;
    domCorrection: number;
    doiCorrection: number;
}

export interface IWeightQueueLogDto {
    id: string;
    timestamp: Date;
    reason: WeightQueueReason;
    reasonDetails?: string;
    actionStatus: QueueActionStatus;
    writtenAtUtc?: Date;
    failedCount: number;
    retryAtUtc?: Date;
    errorMessage?: string;
    isExpired: boolean;
}
export class WeightQueueLogDto extends BaseApiModelClass< IWeightQueueLogDto > implements IWeightQueueLogDto {
    id: string;
    timestamp: Date;
    reason: WeightQueueReason;
    reasonDetails?: string;
    actionStatus: QueueActionStatus;
    writtenAtUtc?: Date;
    failedCount: number;
    retryAtUtc?: Date;
    errorMessage?: string;
    isExpired: boolean;
}

export enum WeightQueueReason {
    DutyChange = "DutyChange",
    AircraftChange = "AircraftChange",
    WeightDataChange = "WeightDataChange",
    WaterCorrectionChange = "WaterCorrectionChange",
    Manual = "Manual",
    CargoChange = "CargoChange",
    PantryOverrideChange = "PantryOverrideChange",
    NoWaterUpliftChange = "NoWaterUpliftChange",
    StationPantryChange = "StationPantryChange",
    AircraftRotationChange = "AircraftRotationChange",
    OriginalFlightChange = "OriginalFlightChange",
    ForceResend = "ForceResend",
    Recheck = "Recheck",
}